import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import {
  FiCalendar,
  FiCheckCircle,
  FiDollarSign,
  FiEdit2,
  FiGift,
  FiPlus,
  FiRefreshCw,
  FiSave,
  FiSettings,
  FiTrash2,
} from "react-icons/fi";
import {
  getConfiguracionesComision,
  postConfiguracionComision,
  putConfiguracionComision,
  getProductosComisiones,
  putProductoComision,
  getPendientesComisiones,
  getLiquidacionesComisiones,
  getPagosComisiones,
  getCuentaCorrienteComision,
  getComisionesValidadas,
  getResumenSemanalComisiones,
  getResumenMensualComisiones,
  getPreviewComisionVenta,
  cerrarLiquidacionMensual,
  cerrarLiquidacionSemanal,
  registrarPagoComision,
  validarComisionVenta,
} from "../helpers/rutaComisiones";
import "./AdministradorComisiones.css";
/* =========================================================
   CONSTANTES
   ========================================================= */
const SEDES = [
  {
    value: "TUCUMAN",
    label: "Tucumán",
  },
  {
    value: "YERBA_BUENA",
    label: "Yerba Buena",
  },
  {
    value: "MIAMI",
    label: "Miami",
  },
];
const fechaHoy = () =>
  new Date().toISOString().slice(0, 10);
const fechaInput = (valor) => {
  if (!valor) return "";
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) {
    return "";
  }
  return d.toISOString().slice(0, 10);
};
const obtenerPeriodoSemana = (
  fechaReferencia
) => {
  if (!fechaReferencia) {
    return {
      desde: "",
      hasta: "",
    };
  }
  const fecha =
    new Date(
      `${fechaReferencia}T00:00:00.000Z`
    );
  if (
    Number.isNaN(
      fecha.getTime()
    )
  ) {
    return {
      desde: "",
      hasta: "",
    };
  }
  const dia =
    fecha.getUTCDay();
  const diferenciaLunes =
    (dia + 6) % 7;
  const lunes =
    new Date(fecha);
  lunes.setUTCDate(
    lunes.getUTCDate() -
      diferenciaLunes
  );
  const domingo =
    new Date(lunes);
  domingo.setUTCDate(
    domingo.getUTCDate() + 6
  );
  return {
    desde:
      lunes
        .toISOString()
        .slice(0, 10),
    hasta:
      domingo
        .toISOString()
        .slice(0, 10),
  };
};
const obtenerPeriodoMensual = (
  fechaInicio,
  semanas = 4
) => {
  if (!fechaInicio) {
    return {
      desde: "",
      hasta: "",
    };
  }
  const desde =
    new Date(
      `${fechaInicio}T00:00:00.000Z`
    );
  if (
    Number.isNaN(
      desde.getTime()
    )
  ) {
    return {
      desde: "",
      hasta: "",
    };
  }
  /*
    El ciclo mensual siempre comienza lunes.
  */
  if (
    desde.getUTCDay() !== 1
  ) {
    return {
      desde: "",
      hasta: "",
    };
  }
  const cantidadSemanas =
    Number(semanas) === 5
      ? 5
      : 4;
  const hasta =
    new Date(desde);
  hasta.setUTCDate(
    hasta.getUTCDate() +
      cantidadSemanas * 7 -
      1
  );
  return {
    desde:
      desde
        .toISOString()
        .slice(0, 10),
    hasta:
      hasta
        .toISOString()
        .slice(0, 10),
  };
};
const formatoUSD = (valor) =>
  Number(valor || 0).toLocaleString(
    "en-US",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  );
const crearFormularioVacio = (
  sede = "TUCUMAN"
) => ({
  _id: null,
  sede,
  activo: true,
  aplicaReglaProgresiva: false,
  tramoPrecioUSD: 100,
  porcentajeVariacion: 10,
  vigenteDesde: fechaHoy(),
  vigenteHasta: "",
  periodoMensual: {
    tipo: "CICLO_SEMANAS",
    diaInicio: 1,
    semanasSugeridas: 4,
  },
  bonosSemanales: {
    activo: true,
    acumulativos: false,
    tramos: [],
  },
  bonosMensuales: {
    activo: true,
    tipo: "CANTIDAD",
    acumulativos: false,
    tramos: [],
    ranking: [],
  },
  observaciones: "",
});
/* =========================================================
   COMPONENTE
   ========================================================= */
export default function AdministradorComisiones() {
  const [
    configuraciones,
    setConfiguraciones,
  ] = useState([]);
  const [
    sedeSeleccionada,
    setSedeSeleccionada,
  ] = useState("TUCUMAN");
  const [
    formulario,
    setFormulario,
  ] = useState(
    crearFormularioVacio("TUCUMAN")
  );
  const [
    tabActiva,
    setTabActiva,
  ] = useState("general");
  const [
    cargando,
    setCargando,
  ] = useState(true);
  const [
    guardando,
    setGuardando,
  ] = useState(false);
  const [
    mensaje,
    setMensaje,
  ] = useState("");
  const [
    error,
    setError,
  ] = useState("");
  const [
  productosComision,
  setProductosComision,
] = useState([]);
const [
  cargandoProductos,
  setCargandoProductos,
] = useState(false);
const [
  guardandoProductoId,
  setGuardandoProductoId,
] = useState("");
const [
  busquedaProducto,
  setBusquedaProducto,
] = useState("");
const [
  nroVentaPreview,
  setNroVentaPreview,
] = useState("");
const [
  previewComision,
  setPreviewComision,
] = useState(null);
const [
  cargandoPreview,
  setCargandoPreview,
] = useState(false);
const [
  validandoComision,
  setValidandoComision,
] = useState(false);
const [
  pendientesComision,
  setPendientesComision,
] = useState([]);
const [
  cargandoPendientes,
  setCargandoPendientes,
] = useState(false);
// Estimación informativa: usa el mismo cálculo del servidor que Vista previa.
const cargaPendientesId = useRef(0);
const [estimacionPendientes, setEstimacionPendientes] = useState({
  porVenta: {}, calculando: false,
});
const resumenEstimacionPendientes = useMemo(() => {
  const valores = Object.values(estimacionPendientes.porVenta);
  const calculadas = valores.filter((item) => item.ok);
  return {
    totalUSD: calculadas.reduce((total, item) => total + item.montoUSD, 0),
    calculadas: calculadas.length,
    errores: valores.filter((item) => !item.ok).length,
  };
}, [estimacionPendientes]);
const [
  filtrosPendientes,
  setFiltrosPendientes,
] = useState({
  sede: "",
  vendedor: "",
  desde: "",
  hasta: "",
});
const [
  comisionesValidadas,
  setComisionesValidadas,
] = useState([]);
const [
  resumenValidadas,
  setResumenValidadas,
] = useState({
  cantidadRegistros: 0,
  cantidadProductos: 0,
  cantidadVendedores: 0,
  totalComisionUSD: 0,
});
const [
  cargandoValidadas,
  setCargandoValidadas,
] = useState(false);
const [
  filtrosValidadas,
  setFiltrosValidadas,
] = useState({
  sede: "",
  desde: "",
  hasta: "",
  nroventa: "",
  liquidada: "",
});
const [
  resumenSemanal,
  setResumenSemanal,
] = useState([]);
const [
  periodoSemanal,
  setPeriodoSemanal,
] = useState({
  desde: "",
  hasta: "",
});
const [
  totalesSemanales,
  setTotalesSemanales,
] = useState({
  cantidadVendedores: 0,
  cantidadVentas: 0,
  cantidadProductos: 0,
  comisionProductosUSD: 0,
  bonosSemanalesUSD: 0,
  totalSemanaUSD: 0,
});
const [
  cargandoResumenSemanal,
  setCargandoResumenSemanal,
] = useState(false);
const [
  sedeResumenSemanal,
  setSedeResumenSemanal,
] = useState("");
const [
  resumenMensual,
  setResumenMensual,
] = useState([]);
const [
  periodoMensualResumen,
  setPeriodoMensualResumen,
] = useState({
  desde: "",
  hasta: "",
  semanas: 0,
});
const [
  totalesMensuales,
  setTotalesMensuales,
] = useState({
  cantidadVendedores: 0,
  cantidadVentas: 0,
  cantidadProductos: 0,
  bonosMensualesUSD: 0,
});
const [
  cargandoResumenMensual,
  setCargandoResumenMensual,
] = useState(false);
const [
  sedeResumenMensual,
  setSedeResumenMensual,
] = useState("");
const [
  fechaInicioResumenMensual,
  setFechaInicioResumenMensual,
] = useState("");
const [
  semanasResumenMensual,
  setSemanasResumenMensual,
] = useState(4);
const [
  cerrandoCicloMensual,
  setCerrandoCicloMensual,
] = useState(false);
const [
  fechaReferenciaSemanal,
  setFechaReferenciaSemanal,
] = useState(fechaHoy());
const [
  cerrandoLiquidacionKey,
  setCerrandoLiquidacionKey,
] = useState("");
const [
  liquidacionesComision,
  setLiquidacionesComision,
] = useState([]);
const [
  cargandoLiquidaciones,
  setCargandoLiquidaciones,
] = useState(false);
const [
  resumenLiquidaciones,
  setResumenLiquidaciones,
] = useState({
  cantidad: 0,
  totalLiquidadoUSD: 0,
  totalPagadoUSD: 0,
  saldoPendienteUSD: 0,
});
const [
  filtrosLiquidaciones,
  setFiltrosLiquidaciones,
] = useState({
  sede: "",
  vendedor: "",
  tipo: "",
  estado: "",
  desde: "",
  hasta: "",
});
const [
  vendedoresLiquidaciones,
  setVendedoresLiquidaciones,
] = useState([]);
const [
  modalPagoAbierto,
  setModalPagoAbierto,
] = useState(false);
const [
  liquidacionPago,
  setLiquidacionPago,
] = useState(null);
const [
  registrandoPago,
  setRegistrandoPago,
] = useState(false);
const [
  formularioPago,
  setFormularioPago,
] = useState({
  montoUSD: "",
  fechaPago: fechaHoy(),
  referencia: "",
  observaciones: "",
});
const [
  pagosComision,
  setPagosComision,
] = useState([]);
const [
  cargandoPagos,
  setCargandoPagos,
] = useState(false);
const [
  resumenPagos,
  setResumenPagos,
] = useState({
  cantidadPagos: 0,
  totalPagadoUSD: 0,
});
const [
  filtrosPagos,
  setFiltrosPagos,
] = useState({
  sede: "",
  estado: "",
  desde: "",
  hasta: "",
});
const [
  movimientosCuentaCorriente,
  setMovimientosCuentaCorriente,
] = useState([]);
const [
  cargandoCuentaCorriente,
  setCargandoCuentaCorriente,
] = useState(false);
const [
  resumenCuentaCorriente,
  setResumenCuentaCorriente,
] = useState({
  totalLiquidacionesUSD: 0,
  totalPagosUSD: 0,
  saldoActualUSD: 0,
});
const [
  vendedorCuentaCorriente,
  setVendedorCuentaCorriente,
] = useState(null);
const [
  sedeCuentaCorriente,
  setSedeCuentaCorriente,
] = useState("");
const periodoSeleccionado =
  useMemo(
    () =>
      obtenerPeriodoSemana(
        fechaReferenciaSemanal
      ),
    [fechaReferenciaSemanal]
  );
const semanaFinalizada =
  Boolean(
    periodoSeleccionado.hasta &&
      fechaHoy() >
        periodoSeleccionado.hasta
  );
  /* =========================================================
     CARGAR CONFIGURACIONES
     ========================================================= */
const cargarConfiguraciones =
  useCallback(async (
    mostrarCarga = true
  ) => {
    try {
      if (mostrarCarga) {
        setCargando(true);
      }
      setError("");
      const resultado =
        await getConfiguracionesComision();
      setConfiguraciones(
        Array.isArray(
          resultado?.configuraciones
        )
          ? resultado.configuraciones
          : []
      );
      return resultado;
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.message ||
          "No se pudieron cargar las configuraciones."
      );
      throw err;
    } finally {
      if (mostrarCarga) {
        setCargando(false);
      }
    }
  }, []);  
  useEffect(() => {
    cargarConfiguraciones();
  }, [cargarConfiguraciones]);
  /* =========================================================
     CONFIGURACIÓN MÁS RECIENTE DE CADA SEDE
     ========================================================= */
  const configuracionPorSede =
    useMemo(() => {
      const mapa = {};
      SEDES.forEach((sede) => {
        const encontradas =
          configuraciones
            .filter(
              (config) =>
                config.sede ===
                sede.value
            )
            .sort(
              (a, b) =>
                new Date(
                  b.vigenteDesde || 0
                ) -
                new Date(
                  a.vigenteDesde || 0
                )
            );
        mapa[sede.value] =
          encontradas[0] || null;
      });
      return mapa;
    }, [configuraciones]);
  /* =========================================================
     CARGAR CONFIGURACIÓN EN FORMULARIO
     ========================================================= */
  const cargarEnFormulario = (
    configuracion
  ) => {
    if (!configuracion) {
      setFormulario(
        crearFormularioVacio(
          sedeSeleccionada
        )
      );
      return;
    }
    setFormulario({
      _id:
        configuracion._id ||
        null,
      sede:
        configuracion.sede,
      activo:
        configuracion.activo !== false,
      aplicaReglaProgresiva:
        configuracion
          .aplicaReglaProgresiva === true,
      tramoPrecioUSD:
        Number(
          configuracion
            .tramoPrecioUSD ?? 100
        ),
      porcentajeVariacion:
        Number(
          configuracion
            .porcentajeVariacion ?? 10
        ),
      vigenteDesde:
        fechaInput(
          configuracion.vigenteDesde
        ),
      vigenteHasta:
        fechaInput(
          configuracion.vigenteHasta
        ),
      periodoMensual: {
        tipo:
          configuracion
            ?.periodoMensual
            ?.tipo ||
          "CICLO_SEMANAS",
        diaInicio:
          Number(
            configuracion
              ?.periodoMensual
              ?.diaInicio ?? 1
          ),
        semanasSugeridas:
          Number(
            configuracion
              ?.periodoMensual
              ?.semanasSugeridas ?? 4
          ),
      },
      bonosSemanales: {
        activo:
          configuracion
            ?.bonosSemanales
            ?.activo !== false,
        acumulativos:
          configuracion
            ?.bonosSemanales
            ?.acumulativos === true,
        tramos:
          Array.isArray(
            configuracion
              ?.bonosSemanales
              ?.tramos
          )
            ? configuracion
                .bonosSemanales
                .tramos
            : [],
      },
      bonosMensuales: {
        activo:
          configuracion
            ?.bonosMensuales
            ?.activo !== false,
        tipo:
          configuracion
            ?.bonosMensuales
            ?.tipo ||
          "CANTIDAD",
        acumulativos:
          configuracion
            ?.bonosMensuales
            ?.acumulativos === true,
        tramos:
          Array.isArray(
            configuracion
              ?.bonosMensuales
              ?.tramos
          )
            ? configuracion
                .bonosMensuales
                .tramos
            : [],
        ranking:
          Array.isArray(
            configuracion
              ?.bonosMensuales
              ?.ranking
          )
            ? configuracion
                .bonosMensuales
                .ranking
            : [],
      },
      observaciones:
        configuracion.observaciones ||
        "",
    });
  };
  /* =========================================================
     CAMBIAR SEDE
     ========================================================= */
  const seleccionarSede = (
    sede
  ) => {
    setSedeSeleccionada(sede);
    setMensaje("");
    setError("");
    const actual =
      configuracionPorSede[
        sede
      ];
    if (actual) {
      cargarEnFormulario(actual);
    } else {
      setFormulario(
        crearFormularioVacio(
          sede
        )
      );
    }
  };
  /*
    Cuando termina de cargar la lista,
    mostramos automáticamente Tucumán.
  */
  useEffect(() => {
    if (cargando) return;
    const actual =
      configuracionPorSede[
        sedeSeleccionada
      ];
    if (actual) {
      cargarEnFormulario(actual);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargando]);
  /* =========================================================
     INPUTS GENERALES
     ========================================================= */
  const cambiarCampo = (
    campo,
    valor
  ) => {
    setFormulario((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };
  const cambiarPeriodo = (
    campo,
    valor
  ) => {
    setFormulario((prev) => ({
      ...prev,
      periodoMensual: {
        ...prev.periodoMensual,
        [campo]: valor,
      },
    }));
  };
  /* =========================================================
     BONOS SEMANALES
     ========================================================= */
  const agregarBonoSemanal = () => {
    setFormulario((prev) => ({
      ...prev,
      bonosSemanales: {
        ...prev.bonosSemanales,
        tramos: [
          ...prev.bonosSemanales
            .tramos,
          {
            cantidad: 1,
            montoUSD: 0,
            activo: true,
          },
        ],
      },
    }));
  };
  const cambiarBonoSemanal = (
    indice,
    campo,
    valor
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosSemanales: {
        ...prev.bonosSemanales,
        tramos:
          prev.bonosSemanales.tramos.map(
            (item, i) =>
              i === indice
                ? {
                    ...item,
                    [campo]:
                      valor,
                  }
                : item
          ),
      },
    }));
  };
  const eliminarBonoSemanal = (
    indice
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosSemanales: {
        ...prev.bonosSemanales,
        tramos:
          prev.bonosSemanales.tramos.filter(
            (_, i) =>
              i !== indice
          ),
      },
    }));
  };
  /* =========================================================
     BONOS MENSUALES POR CANTIDAD
     ========================================================= */
  const agregarBonoMensual = () => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        tramos: [
          ...prev.bonosMensuales
            .tramos,
          {
            cantidad: 1,
            montoUSD: 0,
            activo: true,
          },
        ],
      },
    }));
  };
  const cambiarBonoMensual = (
    indice,
    campo,
    valor
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        tramos:
          prev.bonosMensuales.tramos.map(
            (item, i) =>
              i === indice
                ? {
                    ...item,
                    [campo]:
                      valor,
                  }
                : item
          ),
      },
    }));
  };
  const eliminarBonoMensual = (
    indice
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        tramos:
          prev.bonosMensuales.tramos.filter(
            (_, i) =>
              i !== indice
          ),
      },
    }));
  };
  /* =========================================================
     RANKING MENSUAL
     ========================================================= */
  const agregarRanking = () => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        ranking: [
          ...prev.bonosMensuales
            .ranking,
          {
            puesto:
              prev.bonosMensuales
                .ranking.length +
              1,
            montoUSD: 0,
            activo: true,
          },
        ],
      },
    }));
  };
  const cambiarRanking = (
    indice,
    campo,
    valor
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        ranking:
          prev.bonosMensuales.ranking.map(
            (item, i) =>
              i === indice
                ? {
                    ...item,
                    [campo]:
                      valor,
                  }
                : item
          ),
      },
    }));
  };
  const eliminarRanking = (
    indice
  ) => {
    setFormulario((prev) => ({
      ...prev,
      bonosMensuales: {
        ...prev.bonosMensuales,
        ranking:
          prev.bonosMensuales.ranking.filter(
            (_, i) =>
              i !== indice
          ),
      },
    }));
  };
/* =========================================================
   PRODUCTOS / COMISIONES
   ========================================================= */
const cargarProductos =
  useCallback(async () => {
    try {
      setCargandoProductos(true);
      setError("");
      const resultado =
        await getProductosComisiones();
      setProductosComision(
        Array.isArray(
          resultado?.productos
        )
          ? resultado.productos
          : []
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.message ||
          "No se pudieron cargar los productos."
      );
    } finally {
      setCargandoProductos(false);
    }
  }, []);
useEffect(() => {
  if (
    tabActiva === "productos" &&
    productosComision.length === 0
  ) {
    cargarProductos();
  }
}, [
  tabActiva,
  productosComision.length,
  cargarProductos,
]);
const cambiarProductoComision = (
  id,
  campo,
  valor
) => {
  setProductosComision(
    (prev) =>
      prev.map((producto) =>
        producto._id === id
          ? {
              ...producto,
              [campo]: valor,
            }
          : producto
      )
  );
};
const guardarProductoComision =
  async (producto) => {
    try {
      setGuardandoProductoId(
        producto._id
      );
      setError("");
      setMensaje("");
      const respuesta =
        await putProductoComision(
          producto._id,
          {
            comisiona:
              producto.comisiona,
            comisionBaseUSD:
              producto.comisionBaseUSD,
            comisionMiamiUSD:
              producto.comisionMiamiUSD,
          }
        );
      if (respuesta?.producto) {
        setProductosComision(
          (prev) =>
            prev.map((item) =>
              item._id ===
              producto._id
                ? {
                    ...item,
                    ...respuesta.producto,
                  }
                : item
            )
        );
      }
      setMensaje(
        respuesta?.message ||
          "Comisión del producto actualizada."
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.message ||
          "No se pudo actualizar la comisión del producto."
      );
    } finally {
      setGuardandoProductoId("");
    }
  };
const productosFiltrados =
  useMemo(() => {
    const texto =
      String(
        busquedaProducto || ""
      )
        .trim()
        .toUpperCase();
    if (!texto) {
      return productosComision;
    }
    return productosComision.filter(
      (producto) => {
        const contenido = [
          producto.codprod,
          producto.modelo,
          producto.nombreComercial,
          producto.descripcion,
        ]
          .join(" ")
          .toUpperCase();
        return contenido.includes(
          texto
        );
      }
    );
  }, [
    productosComision,
    busquedaProducto,
  ]);
const validarPreview = async () => {
  const numero =
    Number(
      previewComision
        ?.venta
        ?.nroventa
    );
  if (
    !Number.isFinite(numero) ||
    numero <= 0
  ) {
    setError(
      "Primero calculá una venta válida."
    );
    return;
  }
  const total =
    Number(
      previewComision
        ?.resultado
        ?.totalComisionUSD ||
        0
    );
  const sede =
    previewComision
      ?.venta
      ?.sede ||
    "-";
  const confirmar =
    window.confirm(
      `¿VALIDAR DEFINITIVAMENTE la comisión de la venta N° ${numero}?\n\n` +
      `Sede: ${sede}\n` +
      `Comisión: USD ${formatoUSD(total)}\n\n` +
      `Esta operación generará registros reales de comisión.`
    );
  if (!confirmar) {
    return;
  }
  try {
    setValidandoComision(true);
    setError("");
    setMensaje("");
    const respuesta =
      await validarComisionVenta(
        numero
      );
    setMensaje(
      respuesta?.message ||
        `Comisión de la venta N° ${numero} validada correctamente.`
    );
    /*
      Marcamos visualmente este preview como
      guardado después de una validación exitosa.
    */
    setPreviewComision(
      (prev) => ({
        ...prev,
        guardado: true,
      })
    );
    await cargarPendientes(filtrosPendientes);
  } catch (err) {
    setError(
      err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "No se pudo validar la comisión."
    );
  } finally {
    setValidandoComision(false);
  }
};
/* =========================================================
   PENDIENTES DE VALIDAR
   ========================================================= */
const cargarPendientes =
  useCallback(async (filtros = {}) => {
    const cargaId = ++cargaPendientesId.current;
    try {
      setCargandoPendientes(true);
      setError("");
      const resultado =
        await getPendientesComisiones(filtros);
      if (cargaId !== cargaPendientesId.current) return;
      if (resultado?.ok === false) throw new Error("No se pudieron cargar las ventas pendientes.");
      setPendientesComision(
        Array.isArray(
          resultado?.pendientes
        )
          ? resultado.pendientes
          : []
      );
    } catch (err) {
      if (cargaId !== cargaPendientesId.current) return;
      setPendientesComision([]);
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudieron cargar las ventas pendientes."
      );
    } finally {
      if (cargaId === cargaPendientesId.current) setCargandoPendientes(false);
    }
  }, []);
useEffect(() => {
  if (
    tabActiva === "pendientes"
  ) {
    cargarPendientes();
  }
}, [
  tabActiva,
  cargarPendientes,
]);
// Hasta cuatro consultas de solo lectura simultáneas, con cancelación al actualizar.
useEffect(() => {
  const controller = new AbortController();
  let activa = true;
  setEstimacionPendientes({ porVenta: {}, calculando: !cargandoPendientes && pendientesComision.length > 0 });
  if (cargandoPendientes || pendientesComision.length === 0) {
    return () => { activa = false; controller.abort(); };
  }
  let siguiente = 0;
  const porVenta = {};
  const calcular = async () => {
    while (activa && siguiente < pendientesComision.length) {
      const venta = pendientesComision[siguiente++];
      const numero = Number(venta.nroventa);
      try {
        const preview = await getPreviewComisionVenta(numero, { signal: controller.signal });
        const valor = preview?.resultado?.totalComisionUSD;
        const montoUSD = Number(valor);
        if (preview?.ok === false || valor === undefined || valor === null || valor === "" || !Number.isFinite(montoUSD) || montoUSD < 0) {
          throw new Error("La vista previa no devolvió un importe válido.");
        }
        if (preview?.guardado) throw new Error("La venta ya fue validada. Actualizá los pendientes.");
        porVenta[numero] = { ok: true, montoUSD };
      } catch (err) {
        if (!activa) return;
        porVenta[numero] = { ok: false, error: err?.response?.data?.error || err?.message || "No se pudo estimar." };
      }
      if (activa) setEstimacionPendientes({ porVenta: { ...porVenta }, calculando: true });
    }
  };
  Promise.all(Array.from({ length: Math.min(4, pendientesComision.length) }, calcular))
    .then(() => {
      if (activa) setEstimacionPendientes({ porVenta: { ...porVenta }, calculando: false });
    });
  return () => { activa = false; controller.abort(); };
}, [pendientesComision, cargandoPendientes]);
const verPendiente =
  async (venta) => {
    const numero =
      Number(
        venta?.nroventa
      );
    if (
      !Number.isFinite(numero) ||
      numero <= 0
    ) {
      return;
    }
    try {
      setCargandoPreview(true);
      setError("");
      setMensaje("");
      const resultado =
        await getPreviewComisionVenta(
          numero
        );
      setNroVentaPreview(
        String(numero)
      );
      setPreviewComision(
        resultado
      );
      setTabActiva(
        "preview"
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo abrir la vista previa de la venta."
      );
    } finally {
      setCargandoPreview(false);
    }
  };
/* =========================================================
   HISTORIAL DE COMISIONES VALIDADAS
   ========================================================= */
const cargarValidadas =
  useCallback(async (
    filtros = {}
  ) => {
    try {
      setCargandoValidadas(true);
      setError("");
      const resultado =
        await getComisionesValidadas(
          filtros
        );
      setComisionesValidadas(
        Array.isArray(
          resultado?.comisiones
        )
          ? resultado.comisiones
          : []
      );
      setResumenValidadas(
        resultado?.resumen || {
          cantidadRegistros: 0,
          cantidadProductos: 0,
          cantidadVendedores: 0,
          totalComisionUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudieron cargar las comisiones validadas."
      );
    } finally {
      setCargandoValidadas(false);
    }
  }, []);
useEffect(() => {
  if (
    tabActiva === "historial"
  ) {
    cargarValidadas(
      filtrosValidadas
    );
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  tabActiva,
  cargarValidadas,
]);
const cambiarFiltroValidada = (
  campo,
  valor
) => {
  setFiltrosValidadas(
    (prev) => ({
      ...prev,
      [campo]: valor,
    })
  );
};
const aplicarFiltrosValidadas =
  () => {
    cargarValidadas(
      filtrosValidadas
    );
  };
const limpiarFiltrosValidadas =
  () => {
    const vacios = {
      sede: "",
      desde: "",
      hasta: "",
      nroventa: "",
      liquidada: "",
    };
    setFiltrosValidadas(
      vacios
    );
    cargarValidadas(
      vacios
    );
  };
/* =========================================================
   RESUMEN SEMANAL / PRE-LIQUIDACIÓN
   ========================================================= */
const cargarResumenSemanal =
  useCallback(async ({
    sede = "",
    desde = "",
    hasta = "",
  } = {}) => {
    try {
      setCargandoResumenSemanal(true);
      setError("");
      const resultado =
        await getResumenSemanalComisiones({
          sede,
          desde,
          hasta,
        });
      setResumenSemanal(
        Array.isArray(
          resultado?.resumen
        )
          ? resultado.resumen
          : []
      );
      setPeriodoSemanal(
        resultado?.periodo || {
          desde: "",
          hasta: "",
        }
      );
      setTotalesSemanales(
        resultado?.totales || {
          cantidadVendedores: 0,
          cantidadVentas: 0,
          cantidadProductos: 0,
          comisionProductosUSD: 0,
          bonosSemanalesUSD: 0,
          totalSemanaUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo cargar el resumen semanal."
      );
    } finally {
      setCargandoResumenSemanal(false);
    }
  }, []);
useEffect(() => {
  if (
    tabActiva ===
    "resumen-semanal"
  ) {
    cargarResumenSemanal({
      sede:
        sedeResumenSemanal,
      desde:
        periodoSeleccionado.desde,
      hasta:
        periodoSeleccionado.hasta,
    });
  }
}, [
  tabActiva,
  sedeResumenSemanal,
  periodoSeleccionado.desde,
  periodoSeleccionado.hasta,
  cargarResumenSemanal,
]);
/* =========================================================
   RESUMEN MENSUAL / PRE-LIQUIDACIÓN
   ========================================================= */
const cargarResumenMensual =
  useCallback(async ({
    sede = "",
    desde = "",
    hasta = "",
  } = {}) => {
    if (
      !desde ||
      !hasta
    ) {
      setResumenMensual([]);
      setPeriodoMensualResumen({
        desde: "",
        hasta: "",
        semanas: 0,
      });
      setTotalesMensuales({
        cantidadVendedores: 0,
        cantidadVentas: 0,
        cantidadProductos: 0,
        bonosMensualesUSD: 0,
      });
      return;
    }
    try {
      setCargandoResumenMensual(true);
      setError("");
      const resultado =
        await getResumenMensualComisiones({
          sede,
          desde,
          hasta,
        });
      setResumenMensual(
        Array.isArray(
          resultado?.resumen
        )
          ? resultado.resumen
          : []
      );
      setPeriodoMensualResumen(
        resultado?.periodo || {
          desde: "",
          hasta: "",
          semanas: 0,
        }
      );
      setTotalesMensuales(
        resultado?.totales || {
          cantidadVendedores: 0,
          cantidadVentas: 0,
          cantidadProductos: 0,
          bonosMensualesUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo cargar el resumen mensual."
      );
    } finally {
      setCargandoResumenMensual(false);
    }
  }, []);
const consultarResumenMensual =
  useCallback(async () => {
    const periodo =
      obtenerPeriodoMensual(
        fechaInicioResumenMensual,
        semanasResumenMensual
      );
    if (
      !periodo.desde ||
      !periodo.hasta
    ) {
      setError(
        "El ciclo mensual debe comenzar un lunes."
      );
      return;
    }
    await cargarResumenMensual({
      sede:
        sedeResumenMensual,
      desde:
        periodo.desde,
      hasta:
        periodo.hasta,
    });
  }, [
    fechaInicioResumenMensual,
    semanasResumenMensual,
    sedeResumenMensual,
    cargarResumenMensual,
  ]);
const cerrarCicloMensual =
  async () => {
    const periodo =
      obtenerPeriodoMensual(
        fechaInicioResumenMensual,
        semanasResumenMensual
      );
    if (!sedeResumenMensual) {
      setError(
        "Para cerrar el ciclo mensual debe seleccionar una sede."
      );
      return;
    }
    if (
      !periodo.desde ||
      !periodo.hasta
    ) {
      setError(
        "El ciclo mensual debe comenzar un lunes."
      );
      return;
    }
    if (
      fechaHoy() <=
      periodo.hasta
    ) {
      setError(
        "El ciclo mensual todavía está abierto y no puede cerrarse."
      );
      return;
    }
    /*
      Antes de cerrar obligamos a haber consultado
      exactamente el mismo ciclo que se muestra.
    */
    if (
      periodoMensualResumen.desde !==
        periodo.desde ||
      periodoMensualResumen.hasta !==
        periodo.hasta ||
      resumenMensual.length === 0
    ) {
      setError(
        "Primero consultá este ciclo mensual antes de cerrarlo."
      );
      return;
    }
    /*
      Evitamos cerrar si lo mostrado pertenece
      a otra sede por haber cambiado el selector
      después de realizar la consulta.
    */
    const sedeNoCoincide =
      resumenMensual.some(
        (item) =>
          item.sede !==
          sedeResumenMensual
      );
    if (sedeNoCoincide) {
      setError(
        "La sede cambió después de la consulta. Volvé a consultar el ciclo antes de cerrarlo."
      );
      return;
    }
    const requiereRevision =
      resumenMensual.some(
        (item) =>
          item
            ?.requiereRevisionConfiguracion
      );
    if (requiereRevision) {
      setError(
        "Hay vendedores cuya configuración requiere revisión. El ciclo no puede cerrarse."
      );
      return;
    }
    const vendedoresConBono =
      resumenMensual.filter(
        (item) =>
          Number(
            item?.bonoMensualUSD ||
            0
          ) > 0
      ).length;
    const totalBonos =
      Number(
        totalesMensuales
          ?.bonosMensualesUSD ||
          0
      );
    if (
      vendedoresConBono === 0 ||
      totalBonos <= 0
    ) {
      setError(
        "Este ciclo no posee bonos mensuales para liquidar."
      );
      return;
    }
    const confirmar =
      window.confirm(
        `¿CERRAR DEFINITIVAMENTE este ciclo mensual?\n\n` +
          `Sede: ${sedeResumenMensual}\n` +
          `Período: ${periodo.desde} → ${periodo.hasta}\n` +
          `Vendedores con bono: ${vendedoresConBono}\n` +
          `Total bonos: USD ${formatoUSD(
            totalBonos
          )}\n\n` +
          `Se crearán liquidaciones reales y movimientos de cuenta corriente.`
      );
    if (!confirmar) {
      return;
    }
    try {
      setCerrandoCicloMensual(
        true
      );
      setError("");
      setMensaje("");
      const respuesta =
        await cerrarLiquidacionMensual({
          sede:
            sedeResumenMensual,
          periodoDesde:
            periodo.desde,
          periodoHasta:
            periodo.hasta,
        });
      setMensaje(
        respuesta?.message ||
          "Ciclo mensual cerrado correctamente."
      );
      /*
        Pasamos al historial para ver inmediatamente
        las liquidaciones generadas.
      */
      setTabActiva(
        "liquidaciones"
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo cerrar el ciclo mensual."
      );
    } finally {
      setCerrandoCicloMensual(
        false
      );
    }
  };
const cerrarSemanaVendedor =
  async (item) => {
    if (!semanaFinalizada) {
      setError(
        "La semana todavía está abierta y no puede cerrarse."
      );
      return;
    }
    if (
      item
        ?.requiereRevisionConfiguracion
    ) {
      setError(
        "Esta liquidación requiere revisar la configuración antes de cerrarse."
      );
      return;
    }
    const vendedor =
      [
        item?.vendedor?.nombres,
        item?.vendedor?.apellidos,
      ]
        .filter(Boolean)
        .join(" ") ||
      item?.vendedor?.email ||
      "Vendedor";
    const confirmar =
      window.confirm(
        `¿CERRAR DEFINITIVAMENTE esta liquidación semanal?\n\n` +
          `Vendedor: ${vendedor}\n` +
          `Sede: ${item.sede}\n` +
          `Período: ${periodoSemanal.desde} → ${periodoSemanal.hasta}\n` +
          `Comisiones: USD ${formatoUSD(
            item.comisionProductosUSD
          )}\n` +
          `Bono: USD ${formatoUSD(
            item.bonoSemanalUSD
          )}\n` +
          `TOTAL: USD ${formatoUSD(
            item.totalSemanaUSD
          )}\n\n` +
          `Las comisiones quedarán marcadas como liquidadas, pero todavía NO pagadas.`
      );
    if (!confirmar) {
      return;
    }
    const key =
      `${item.vendedorId}-${item.sede}`;
    try {
      setCerrandoLiquidacionKey(
        key
      );
      setError("");
      setMensaje("");
      const respuesta =
        await cerrarLiquidacionSemanal({
          vendedor:
            item.vendedorId,
          sede:
            item.sede,
          periodoDesde:
            periodoSemanal.desde,
          periodoHasta:
            periodoSemanal.hasta,
        });
      setMensaje(
        respuesta?.message ||
          "Liquidación semanal cerrada correctamente."
      );
      await cargarResumenSemanal({
        sede:
          sedeResumenSemanal,
        desde:
          periodoSeleccionado.desde,
        hasta:
          periodoSeleccionado.hasta,
      });
      await cargarValidadas(
        filtrosValidadas
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo cerrar la liquidación semanal."
      );
    } finally {
      setCerrandoLiquidacionKey(
        ""
      );
    }
  };
  /* =========================================================
   LIQUIDACIONES
   ========================================================= */
const cargarLiquidaciones =
  useCallback(async (
    filtros = {}
  ) => {
    try {
      setCargandoLiquidaciones(true);
      setError("");
      const resultado =
        await getLiquidacionesComisiones(
          filtros
        );
      const lista =
        Array.isArray(
          resultado?.liquidaciones
        )
          ? resultado.liquidaciones
          : [];
      setLiquidacionesComision(
        lista
      );
      /*
        Conservamos la lista de vendedores
        cuando cargamos sin filtro de vendedor.
      */
      if (!filtros?.vendedor) {
        const mapa =
          new Map();
        lista.forEach(
          (liquidacion) => {
            const vendedor =
              liquidacion?.vendedor;
            const id =
              vendedor?._id;
            if (!id) return;
            const nombre =
              [
                vendedor?.nombres,
                vendedor?.apellidos,
              ]
                .filter(Boolean)
                .join(" ") ||
              vendedor?.email ||
              "Vendedor";
            mapa.set(
              String(id),
              {
                id: String(id),
                nombre,
              }
            );
          }
        );
        setVendedoresLiquidaciones(
          Array.from(
            mapa.values()
          ).sort(
            (a, b) =>
              a.nombre.localeCompare(
                b.nombre
              )
          )
        );
      }
      setResumenLiquidaciones(
        resultado?.resumen || {
          cantidad: 0,
          totalLiquidadoUSD: 0,
          totalPagadoUSD: 0,
          saldoPendienteUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudieron cargar las liquidaciones."
      );
    } finally {
      setCargandoLiquidaciones(false);
    }
  }, []);
useEffect(() => {
  if (
    tabActiva ===
    "liquidaciones"
  ) {
    cargarLiquidaciones(
      filtrosLiquidaciones
    );
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  tabActiva,
  cargarLiquidaciones,
]);
const abrirPagoLiquidacion = (
  liquidacion
) => {
  const saldo =
    Number(
      liquidacion
        ?.saldoPendienteUSD ||
        0
    );
  if (saldo <= 0) {
    setError(
      "Esta liquidación no posee saldo pendiente."
    );
    return;
  }
  setLiquidacionPago(
    liquidacion
  );
  setFormularioPago({
    montoUSD: "",
    fechaPago: fechaHoy(),
    referencia: "",
    observaciones: "",
  });
  setError("");
  setMensaje("");
  setModalPagoAbierto(true);
};
const cerrarModalPago = () => {
  if (registrandoPago) {
    return;
  }
  setModalPagoAbierto(false);
  setLiquidacionPago(null);
};
const registrarPagoLiquidacion =
  async () => {
    if (
      !liquidacionPago?._id
    ) {
      return;
    }
    const monto =
      Number(
        formularioPago.montoUSD
      );
    const saldo =
      Number(
        liquidacionPago
          .saldoPendienteUSD ||
          0
      );
    if (
      !Number.isFinite(monto) ||
      monto <= 0
    ) {
      setError(
        "Ingresá un monto de pago válido."
      );
      return;
    }
    if (monto > saldo) {
      setError(
        `El pago no puede superar el saldo pendiente de USD ${formatoUSD(
          saldo
        )}.`
      );
      return;
    }
    const vendedor =
      [
        liquidacionPago
          ?.vendedor
          ?.nombres,
        liquidacionPago
          ?.vendedor
          ?.apellidos,
      ]
        .filter(Boolean)
        .join(" ") ||
      liquidacionPago
        ?.vendedor
        ?.email ||
      "Vendedor";
    const confirmar =
      window.confirm(
        `¿REGISTRAR este pago de comisión?\n\n` +
          `Vendedor: ${vendedor}\n` +
          `Tipo: ${
            liquidacionPago.tipo === "MENSUAL"
              ? "Mensual"
              : "Semanal"
          }\n` +
          `Período: ${fechaInput(
            liquidacionPago.periodoDesde
          )} → ${fechaInput(
            liquidacionPago.periodoHasta
          )}\n` +
          `Monto: USD ${formatoUSD(
            monto
          )}\n` +
          `Saldo actual: USD ${formatoUSD(
            saldo
          )}\n` +
          `Saldo posterior: USD ${formatoUSD(
            saldo - monto
          )}`
      );
    if (!confirmar) {
      return;
    }
    try {
      setRegistrandoPago(true);
      setError("");
      setMensaje("");
      const respuesta =
        await registrarPagoComision({
          liquidacionId:
            liquidacionPago._id,
          montoUSD:
            monto,
          fechaPago:
            formularioPago.fechaPago,
          referencia:
            formularioPago.referencia,
          observaciones:
            formularioPago.observaciones,
        });
      setMensaje(
        respuesta?.message ||
          "Pago registrado correctamente."
      );
      setModalPagoAbierto(false);
      setLiquidacionPago(null);
      await cargarLiquidaciones(
        filtrosLiquidaciones
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo registrar el pago."
      );
    } finally {
      setRegistrandoPago(false);
    }
  };
/* =========================================================
   HISTORIAL DE PAGOS
   ========================================================= */
const cargarPagos =
  useCallback(async (
    filtros = {}
  ) => {
    try {
      setCargandoPagos(true);
      setError("");
      const resultado =
        await getPagosComisiones(
          filtros
        );
      setPagosComision(
        Array.isArray(
          resultado?.pagos
        )
          ? resultado.pagos
          : []
      );
      setResumenPagos(
        resultado?.resumen || {
          cantidadPagos: 0,
          totalPagadoUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudieron cargar los pagos."
      );
    } finally {
      setCargandoPagos(false);
    }
  }, []);
  useEffect(() => {
    if (
      tabActiva === "pagos"
    ) {
      cargarPagos(
        filtrosPagos
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabActiva,
    cargarPagos,
  ]);
  /* =========================================================
   CUENTA CORRIENTE DEL VENDEDOR
   ========================================================= */
const cargarCuentaCorriente =
  useCallback(async ({
    vendedor,
    sede = "",
  } = {}) => {
    const vendedorId =
      typeof vendedor === "string"
        ? vendedor
        : vendedor?._id;
    if (!vendedorId) {
      setError(
        "Debe seleccionar un vendedor."
      );
      return;
    }
    try {
      setCargandoCuentaCorriente(true);
      setError("");
      const resultado =
        await getCuentaCorrienteComision({
          vendedor:
            vendedorId,
          sede,
        });
      setVendedorCuentaCorriente(
        resultado?.vendedor ||
          (typeof vendedor === "object"
            ? vendedor
            : null)
      );
      setSedeCuentaCorriente(
        sede || ""
      );
      setMovimientosCuentaCorriente(
        Array.isArray(
          resultado?.movimientos
        )
          ? resultado.movimientos
          : []
      );
      setResumenCuentaCorriente(
        resultado?.resumen || {
          totalLiquidacionesUSD: 0,
          totalPagosUSD: 0,
          saldoActualUSD: 0,
        }
      );
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo cargar la cuenta corriente."
      );
    } finally {
      setCargandoCuentaCorriente(false);
    }
  }, []);
const abrirCuentaCorriente = async (
  liquidacion
) => {
  const vendedor =
    liquidacion?.vendedor;
  const vendedorId =
    typeof vendedor === "string"
      ? vendedor
      : vendedor?._id;
  if (!vendedorId) {
    setError(
      "No se pudo identificar al vendedor."
    );
    return;
  }
  setTabActiva(
    "cuenta-corriente"
  );
  await cargarCuentaCorriente({
    vendedor,
    sede:
      liquidacion?.sede || "",
  });
};
/* =========================================================
   VISTA PREVIA DE COMISIÓN
   ========================================================= */
const calcularPreview = async () => {
  const numero =
    Number(nroVentaPreview);
  if (
    !Number.isFinite(numero) ||
    numero <= 0
  ) {
    setError(
      "Ingresá un número de venta válido."
    );
    return;
  }
  try {
    setCargandoPreview(true);
    setError("");
    setMensaje("");
    setPreviewComision(null);
    const resultado =
      await getPreviewComisionVenta(
        numero
      );
    setPreviewComision(
      resultado
    );
  } catch (err) {
    setPreviewComision(null);
    setError(
      err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "No se pudo calcular la vista previa."
    );
  } finally {
    setCargandoPreview(false);
  }
};
  /* =========================================================
     NUEVA VIGENCIA
     ========================================================= */
  const nuevaVigencia = () => {
    const nuevo =
      crearFormularioVacio(
        sedeSeleccionada
      );
    /*
      Conservamos algunas reglas actuales
      para facilitar la carga de una nueva
      vigencia.
    */
    nuevo.aplicaReglaProgresiva =
      formulario.aplicaReglaProgresiva;
    nuevo.tramoPrecioUSD =
      formulario.tramoPrecioUSD;
    nuevo.porcentajeVariacion =
      formulario.porcentajeVariacion;
    nuevo.bonosSemanales =
      JSON.parse(
        JSON.stringify(
          formulario.bonosSemanales
        )
      );
    nuevo.bonosMensuales =
      JSON.parse(
        JSON.stringify(
          formulario.bonosMensuales
        )
      );
    nuevo.periodoMensual =
      JSON.parse(
        JSON.stringify(
          formulario.periodoMensual
        )
      );
    setFormulario(nuevo);
    setMensaje(
      "Nueva vigencia preparada. Al guardar se creará una configuración nueva."
    );
  };
  /* =========================================================
     VALIDAR
     ========================================================= */
  const validarFormulario = () => {
    if (!formulario.sede) {
      return "Debe seleccionar una sede.";
    }
    if (
      !formulario.vigenteDesde
    ) {
      return "Debe indicar la fecha de inicio de vigencia.";
    }
    if (
      formulario.aplicaReglaProgresiva &&
      Number(
        formulario.tramoPrecioUSD
      ) <= 0
    ) {
      return "El tramo de precio debe ser mayor que cero.";
    }
    return "";
  };
  /* =========================================================
     GUARDAR
     ========================================================= */
  const guardar = async () => {
    const errorValidacion =
      validarFormulario();
    if (errorValidacion) {
      setError(
        errorValidacion
      );
      return;
    }
    try {
      setGuardando(true);
      setError("");
      setMensaje("");
      let respuesta;
      if (formulario._id) {
        respuesta =
          await putConfiguracionComision(
            formulario._id,
            formulario
          );
      } else {
        respuesta =
          await postConfiguracionComision(
            formulario
          );
      }
      setMensaje(
        respuesta?.message ||
          "Configuración guardada correctamente."
      );
      await cargarConfiguraciones(false);
      if (
        respuesta?.configuracion
      ) {
        cargarEnFormulario(
          respuesta.configuracion
        );
      }
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo guardar la configuración."
      );
    } finally {
      setGuardando(false);
    }
  };
  /* =========================================================
     UI
     ========================================================= */
  if (cargando) {
    return (
      <div className="comisiones-loading">
        <Spinner
          animation="border"
          size="sm"
        />
        <span>
          Cargando configuración de
          comisiones...
        </span>
      </div>
    );
  }
  return (
    <Container
      fluid
      className="admin-comisiones py-3"
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
        <div>
          <div className="d-flex align-items-center gap-2">
            <div className="comisiones-icono-principal">
              <FiDollarSign />
            </div>
            <div>
              <h3 className="mb-0 fw-bold">
                Administrador de
                Comisiones
              </h3>
              <div className="text-muted">
                Configuración central de
                reglas, bonos y vigencias
              </div>
            </div>
          </div>
        </div>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={
            cargarConfiguraciones
          }
        >
          <FiRefreshCw className="me-1" />
          Actualizar
        </Button>
      </div>
      {/* MENSAJES */}
      {error && (
        <Alert
          variant="danger"
          dismissible
          onClose={() =>
            setError("")
          }
        >
          {error}
        </Alert>
      )}
     <Alert
      variant="success"
      className={
          mensaje
          ? "py-2"
          : "d-none"
      }
      >
      {mensaje || ""}
     </Alert>
      {/* TARJETAS SEDES */}
      <Row className="g-3 mb-3">
        {SEDES.map((sede) => {
          const config =
            configuracionPorSede[
              sede.value
            ];
          const seleccionada =
            sedeSeleccionada ===
            sede.value;
          return (
            <Col
              key={sede.value}
              xs={12}
              md={4}
            >
              <Card
                className={`sede-card ${
                  seleccionada
                    ? "sede-card-activa"
                    : ""
                }`}
                onClick={() =>
                  seleccionarSede(
                    sede.value
                  )
                }
              >
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div className="small text-muted">
                        Sede
                      </div>
                      <div className="fw-bold">
                        {sede.label}
                      </div>
                    </div>
                    {config ? (
                      <Badge
                        bg={
                          config.activo !==
                          false
                            ? "success"
                            : "secondary"
                        }
                      >
                        {config.activo !==
                        false
                          ? "Activa"
                          : "Inactiva"}
                      </Badge>
                    ) : (
                      <Badge bg="secondary">
                        Sin configuración
                      </Badge>
                    )}
                  </div>
                  <div className="small text-muted mt-3">
                    <FiCalendar className="me-1" />
                    {config
                      ? `${fechaInput(
                          config.vigenteDesde
                        )}${
                          config.vigenteHasta
                            ? ` → ${fechaInput(
                                config.vigenteHasta
                              )}`
                            : " → sin vencimiento"
                        }`
                      : "No configurada"}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row className="g-3">
        {/* PANEL PRINCIPAL */}
        <Col
          xs={12}
          xl={9}
        >
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Tabs
                activeKey={tabActiva}
                onSelect={(key) =>
                  setTabActiva(key)
                }
                className="mb-4"
              >
                {/* GENERAL */}
                <Tab
                eventKey="general"
                title="General"
                >
                {formulario._id && (
                    <Alert
                    variant="info"
                    className="py-2 mb-3"
                    >
                    <FiEdit2 className="me-2" />
                    Editando configuración existente de{" "}
                    <strong>{formulario.sede}</strong>.
                    Los cambios se guardarán sobre esta vigencia.
                    </Alert>
                )}
                <Row className="g-3">
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            formulario.sede
                          }
                          onChange={(e) =>
                            seleccionarSede(
                              e.target.value
                            )
                          }
                        >
                          {SEDES.map(
                            (sede) => (
                              <option
                                key={
                                  sede.value
                                }
                                value={
                                  sede.value
                                }
                              >
                                {
                                  sede.label
                                }
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Group>
                        <Form.Label>
                          Vigente desde
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            formulario.vigenteDesde
                          }
                          onChange={(e) =>
                            cambiarCampo(
                              "vigenteDesde",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Group>
                        <Form.Label>
                          Vigente hasta
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            formulario.vigenteHasta
                          }
                          onChange={(e) =>
                            cambiarCampo(
                              "vigenteHasta",
                              e.target.value
                            )
                          }
                        />
                        <Form.Text muted>
                          Vacío = sin
                          vencimiento.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Check
                        type="switch"
                        label="Configuración activa"
                        checked={
                          formulario.activo
                        }
                        onChange={(e) =>
                          cambiarCampo(
                            "activo",
                            e.target
                              .checked
                          )
                        }
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Check
                        type="switch"
                        label="Aplicar regla progresiva"
                        checked={
                          formulario.aplicaReglaProgresiva
                        }
                        onChange={(e) =>
                          cambiarCampo(
                            "aplicaReglaProgresiva",
                            e.target
                              .checked
                          )
                        }
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={2}
                    >
                      <Form.Group>
                        <Form.Label>
                          Tramo USD
                        </Form.Label>
                        <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        value={
                            formulario.tramoPrecioUSD
                        }
                          onChange={(e) =>
                            cambiarCampo(
                              "tramoPrecioUSD",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={2}
                    >
                      <Form.Group>
                        <Form.Label>
                          Variación %
                        </Form.Label>
                        <Form.Control
                        type="number"
                        min="0"
                        step="0.01"
                        value={
                            formulario.porcentajeVariacion
                        }
                          onChange={(e) =>
                            cambiarCampo(
                              "porcentajeVariacion",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Group>
                        <Form.Label>
                          Período mensual
                        </Form.Label>
                        <Form.Select
                          value={
                            formulario
                              .periodoMensual
                              .tipo
                          }
                          onChange={(e) =>
                            cambiarPeriodo(
                              "tipo",
                              e.target.value
                            )
                          }
                        >
                          <option value="CICLO_SEMANAS">
                            Ciclo de semanas
                          </option>
                          <option value="MES_CALENDARIO">
                            Mes calendario
                          </option>
                          <option value="DIA_CORTE">
                            Día de corte
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                    >
                      {formulario
                        .periodoMensual
                        .tipo ===
                      "CICLO_SEMANAS" ? (
                        <Form.Group>
                          <Form.Label>
                            Semanas sugeridas
                          </Form.Label>
                          <Form.Select
                            value={
                              formulario
                                .periodoMensual
                                .semanasSugeridas
                            }
                            onChange={(e) =>
                              cambiarPeriodo(
                                "semanasSugeridas",
                                Number(
                                  e.target.value
                                )
                              )
                            }
                          >
                            <option value={4}>
                              4 semanas
                            </option>
                            <option value={5}>
                              5 semanas
                            </option>
                          </Form.Select>
                        </Form.Group>
                      ) : (
                        <Form.Group>
                          <Form.Label>
                            Día inicio /
                            corte
                          </Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            max="28"
                            value={
                              formulario
                                .periodoMensual
                                .diaInicio
                            }
                            onChange={(e) =>
                              cambiarPeriodo(
                                "diaInicio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      )}
                    </Col>
                    <Col
                      xs={12}
                      md={5}
                    >
                      <Form.Group>
                        <Form.Label>
                          Observaciones
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={
                            formulario.observaciones
                          }
                          onChange={(e) =>
                            cambiarCampo(
                              "observaciones",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Tab>
                {/* BONOS SEMANALES */}
                <Tab
                  eventKey="semanales"
                  title="Bonos semanales"
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <Form.Check
                        type="switch"
                        label="Bonos semanales activos"
                        checked={
                          formulario
                            .bonosSemanales
                            .activo
                        }
                        onChange={(e) =>
                          setFormulario(
                            (prev) => ({
                              ...prev,
                              bonosSemanales:
                                {
                                  ...prev.bonosSemanales,
                                  activo:
                                    e
                                      .target
                                      .checked,
                                },
                            })
                          )
                        }
                      />
                      <Form.Check
                        className="mt-2"
                        type="switch"
                        label="Los tramos son acumulativos"
                        checked={
                          formulario
                            .bonosSemanales
                            .acumulativos
                        }
                        onChange={(e) =>
                          setFormulario(
                            (prev) => ({
                              ...prev,
                              bonosSemanales:
                                {
                                  ...prev.bonosSemanales,
                                  acumulativos:
                                    e
                                      .target
                                      .checked,
                                },
                            })
                          )
                        }
                      />
                    </div>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={
                        agregarBonoSemanal
                      }
                    >
                      <FiPlus className="me-1" />
                      Agregar tramo
                    </Button>
                  </div>
                  <Table
                    responsive
                    hover
                    className="align-middle"
                  >
                    <thead>
                      <tr>
                        <th>
                          Cantidad ventas
                        </th>
                        <th>
                          Bono USD
                        </th>
                        <th
                          style={{
                            width:
                              "80px",
                          }}
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {formulario
                        .bonosSemanales
                        .tramos.length ===
                      0 ? (
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center text-muted py-4"
                          >
                            No hay bonos
                            semanales
                            configurados.
                          </td>
                        </tr>
                      ) : (
                        formulario.bonosSemanales.tramos.map(
                          (
                            bono,
                            indice
                          ) => (
                            <tr
                              key={
                                bono._id ||
                                indice
                              }
                            >
                              <td>
                                <Form.Control
                                  type="number"
                                  min="1"
                                  value={
                                    bono.cantidad
                                  }
                                  onChange={(
                                    e
                                  ) =>
                                    cambiarBonoSemanal(
                                      indice,
                                      "cantidad",
                                      e
                                        .target
                                        .value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  value={
                                    bono.montoUSD
                                  }
                                  onChange={(
                                    e
                                  ) =>
                                    cambiarBonoSemanal(
                                      indice,
                                      "montoUSD",
                                      e
                                        .target
                                        .value
                                    )
                                  }
                                />
                              </td>
                              <td className="text-end">
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() =>
                                    eliminarBonoSemanal(
                                      indice
                                    )
                                  }
                                >
                                  <FiTrash2 />
                                </Button>
                              </td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  </Table>
                </Tab>
                {/* BONOS MENSUALES */}
                <Tab
                  eventKey="mensuales"
                  title="Bonos mensuales"
                >
                  <Row className="g-3 mb-3">
                    <Col md={4}>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Check
                          type="switch"
                          checked={
                            formulario
                              .bonosMensuales
                              .activo
                          }
                          onChange={(e) =>
                            setFormulario(
                              (prev) => ({
                                ...prev,
                                bonosMensuales: {
                                  ...prev.bonosMensuales,
                                  activo:
                                    e.target.checked,
                                },
                              })
                            )
                          }
                        />
                        <span className="fw-semibold">
                          Bonos mensuales
                        </span>
                        <Badge
                          bg={
                            formulario
                              .bonosMensuales
                              .activo
                              ? "success"
                              : "secondary"
                          }
                        >
                          {formulario
                            .bonosMensuales
                            .activo
                            ? "ACTIVOS"
                            : "INACTIVOS"}
                        </Badge>
                      </div>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>
                          Tipo
                        </Form.Label>
                        <Form.Select
                          value={
                            formulario
                              .bonosMensuales
                              .tipo
                          }
                          onChange={(e) =>
                            setFormulario(
                              (prev) => ({
                                ...prev,
                                bonosMensuales:
                                  {
                                    ...prev.bonosMensuales,
                                    tipo:
                                      e
                                        .target
                                        .value,
                                  },
                              })
                            )
                          }
                        >
                          <option value="CANTIDAD">
                            Cantidad de productos
                          </option>
                          <option value="RANKING">
                            Ranking
                          </option>
                          <option value="NINGUNO">
                            Ninguno
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Check
                        className="mt-md-4"
                        type="switch"
                        label="Tramos acumulativos"
                        checked={
                          formulario
                            .bonosMensuales
                            .acumulativos
                        }
                        onChange={(e) =>
                          setFormulario(
                            (prev) => ({
                              ...prev,
                              bonosMensuales:
                                {
                                  ...prev.bonosMensuales,
                                  acumulativos:
                                    e
                                      .target
                                      .checked,
                                },
                            })
                          )
                        }
                      />
                    </Col>
                  </Row>
                  {formulario
                    .bonosMensuales
                    .tipo ===
                    "CANTIDAD" && (
                    <>
                      <div className="text-end mb-2">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={
                            agregarBonoMensual
                          }
                        >
                          <FiPlus className="me-1" />
                          Agregar tramo
                        </Button>
                      </div>
                      <Table
                        responsive
                        hover
                        className="align-middle"
                      >
                        <thead>
                          <tr>
                            <th>
                              Cantidad
                              productos
                            </th>
                            <th>
                              Bono USD
                            </th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {formulario.bonosMensuales.tramos.map(
                            (
                              bono,
                              indice
                            ) => (
                              <tr
                                key={
                                  bono._id ||
                                  indice
                                }
                              >
                                <td>
                                  <Form.Control
                                    type="number"
                                    min="1"
                                    value={
                                      bono.cantidad
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      cambiarBonoMensual(
                                        indice,
                                        "cantidad",
                                        e
                                          .target
                                          .value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    min="0"
                                    value={
                                      bono.montoUSD
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      cambiarBonoMensual(
                                        indice,
                                        "montoUSD",
                                        e
                                          .target
                                          .value
                                      )
                                    }
                                  />
                                </td>
                                <td className="text-end">
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() =>
                                      eliminarBonoMensual(
                                        indice
                                      )
                                    }
                                  >
                                    <FiTrash2 />
                                  </Button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </>
                  )}
                  {formulario
                    .bonosMensuales
                    .tipo ===
                    "RANKING" && (
                    <>
                      <div className="text-end mb-2">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={
                            agregarRanking
                          }
                        >
                          <FiPlus className="me-1" />
                          Agregar puesto
                        </Button>
                      </div>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>
                              Puesto
                            </th>
                            <th>
                              Premio USD
                            </th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {formulario.bonosMensuales.ranking.map(
                            (
                              item,
                              indice
                            ) => (
                              <tr
                                key={
                                  item._id ||
                                  indice
                                }
                              >
                                <td>
                                  <Form.Control
                                    type="number"
                                    min="1"
                                    value={
                                      item.puesto
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      cambiarRanking(
                                        indice,
                                        "puesto",
                                        e
                                          .target
                                          .value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    min="0"
                                    value={
                                      item.montoUSD
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      cambiarRanking(
                                        indice,
                                        "montoUSD",
                                        e
                                          .target
                                          .value
                                      )
                                    }
                                  />
                                </td>
                                <td className="text-end">
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() =>
                                      eliminarRanking(
                                        indice
                                      )
                                    }
                                  >
                                    <FiTrash2 />
                                  </Button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </>
                  )}
                </Tab>
                {/* FUTURO */}
                <Tab
                eventKey="productos"
                title="Productos"
                >
                <div className="d-flex justify-content-between align-items-end flex-wrap gap-2 mb-3">
                    <div>
                    <h6 className="fw-bold mb-1">
                        Comisión por producto
                    </h6>
                    <div className="small text-muted">
                        Comisión base Tucumán y
                        comisión específica Miami.
                    </div>
                    </div>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={cargarProductos}
                    disabled={cargandoProductos}
                  >
                    <FiRefreshCw className="me-1" />
                    Actualizar
                  </Button>
                </div>
                <Row className="g-2 mb-3">
                    <Col
                    xs={12}
                    md={6}
                    >
                    <Form.Control
                        type="text"
                        placeholder="Buscar por código, modelo o nombre..."
                        value={busquedaProducto}
                        onChange={(e) =>
                        setBusquedaProducto(
                            e.target.value
                        )
                        }
                    />
                    </Col>
                    <Col
                    xs={12}
                    md={6}
                    className="d-flex align-items-center"
                    >
                    <div className="small text-muted">
                        {productosFiltrados.length} productos
                    </div>
                    </Col>
                </Row>
                {cargandoProductos ? (
                    <div className="text-center py-5">
                    <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                    />
                    Cargando productos...
                    </div>
                ) : (
                    <Table
                    responsive
                    hover
                    className="align-middle"
                    >
                    <thead>
                        <tr>
                        <th>Cód.</th>
                        <th>Producto</th>
                        <th>Precio lista</th>
                        <th className="text-center">
                            Comisiona
                        </th>
                        <th>
                            Comisión Tucumán
                        </th>
                        <th>
                            Comisión Miami
                        </th>
                        <th
                            className="text-end"
                            style={{
                            width: "90px",
                            }}
                        >
                            Acción
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosFiltrados.length ===
                        0 ? (
                        <tr>
                            <td
                            colSpan={7}
                            className="text-center text-muted py-4"
                            >
                            No hay productos para mostrar.
                            </td>
                        </tr>
                        ) : (
                        productosFiltrados.map(
                            (producto) => (
                            <tr
                                key={producto._id}
                            >
                                <td>
                                {producto.codprod}
                                </td>
                                <td>
                                <div className="fw-semibold">
                                    {producto.modelo ||
                                    producto.nombreComercial ||
                                    "Sin nombre"}
                                </div>
                                {producto.nombreComercial &&
                                    producto.nombreComercial !==
                                    producto.modelo && (
                                    <div className="small text-muted">
                                        {
                                        producto.nombreComercial
                                        }
                                    </div>
                                    )}
                                </td>
                                <td>
                                USD{" "}
                                {Number(
                                    producto.precioVentaUSD ||
                                    0
                                ).toLocaleString(
                                    "en-US"
                                )}
                                </td>
                                <td className="text-center">
                                  <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Form.Check
                                      type="switch"
                                      className="mb-0"
                                      checked={
                                        producto.comisiona !== false
                                      }
                                      onChange={(e) =>
                                        cambiarProductoComision(
                                          producto._id,
                                          "comisiona",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <Badge
                                      bg={
                                        producto.comisiona !== false
                                          ? "success"
                                          : "secondary"
                                      }
                                    >
                                      {producto.comisiona !== false
                                        ? "SÍ"
                                        : "NO"}
                                    </Badge>
                                  </div>
                                </td>
                                <td>
                                <Form.Control
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={
                                    producto.comisionBaseUSD
                                    }
                                    disabled={
                                    producto.comisiona ===
                                    false
                                    }
                                    onChange={(e) =>
                                    cambiarProductoComision(
                                        producto._id,
                                        "comisionBaseUSD",
                                        e.target.value
                                    )
                                    }
                                />
                                </td>
                                <td>
                                <Form.Control
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={
                                    producto.comisionMiamiUSD
                                    }
                                    disabled={
                                    producto.comisiona ===
                                    false
                                    }
                                    onChange={(e) =>
                                    cambiarProductoComision(
                                        producto._id,
                                        "comisionMiamiUSD",
                                        e.target.value
                                    )
                                    }
                                />
                                </td>
                                <td className="text-end">
                                <Button
                                    size="sm"
                                    variant="outline-primary"
                                    disabled={
                                    guardandoProductoId ===
                                    producto._id
                                    }
                                    onClick={() =>
                                    guardarProductoComision(
                                        producto
                                    )
                                    }
                                >
                                    {guardandoProductoId ===
                                    producto._id ? (
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                    />
                                    ) : (
                                    <FiSave />
                                    )}
                                </Button>
                                </td>
                            </tr>
                            )
                        )
                        )}
                    </tbody>
                    </Table>
                )}
                </Tab>
                <Tab
                  eventKey="historial"
                  title="Historial"
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <h6 className="fw-bold mb-1">
                        Comisiones validadas
                      </h6>
                      <div className="small text-muted">
                        Historial según la fecha original
                        de cada venta.
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        cargarValidadas(
                          filtrosValidadas
                        )
                      }
                      disabled={
                        cargandoValidadas
                      }
                    >
                      <FiRefreshCw className="me-1" />
                      Actualizar
                    </Button>
                  </div>
                  {/* FILTROS */}
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Desde
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosValidadas.desde
                          }
                          onChange={(e) =>
                            cambiarFiltroValidada(
                              "desde",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Hasta
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosValidadas.hasta
                          }
                          onChange={(e) =>
                            cambiarFiltroValidada(
                              "hasta",
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosValidadas.sede
                          }
                          onChange={(e) =>
                            cambiarFiltroValidada(
                              "sede",
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map(
                            (sede) => (
                              <option
                                key={
                                  sede.value
                                }
                                value={
                                  sede.value
                                }
                              >
                                {sede.label}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Venta
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          value={
                            filtrosValidadas.nroventa
                          }
                          onChange={(e) =>
                            cambiarFiltroValidada(
                              "nroventa",
                              e.target.value
                            )
                          }
                          placeholder="N°"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Liquidada
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosValidadas.liquidada
                          }
                          onChange={(e) =>
                            cambiarFiltroValidada(
                              "liquidada",
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          <option value="false">
                            No
                          </option>
                          <option value="true">
                            Sí
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={2}
                      className="d-flex align-items-end gap-2"
                    >
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={
                          aplicarFiltrosValidadas
                        }
                      >
                        Aplicar
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={
                          limpiarFiltrosValidadas
                        }
                      >
                        Limpiar
                      </Button>
                    </Col>
                  </Row>
                  {/* RESUMEN */}
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={4}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Registros
                          </div>
                          <div className="fs-5 fw-bold">
                            {Number(
                              resumenValidadas
                                .cantidadRegistros ||
                                0
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={12} md={4}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Productos
                          </div>
                          <div className="fs-5 fw-bold">
                            {Number(
                              resumenValidadas
                                .cantidadProductos ||
                                0
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={12} md={4}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Total comisión
                          </div>
                          <div className="fs-5 fw-bold text-success">
                            USD{" "}
                            {formatoUSD(
                              resumenValidadas
                                .totalComisionUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {/* TABLA */}
                  {cargandoValidadas ? (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Cargando historial...
                    </div>
                  ) : (
                    <Table
                      responsive
                      hover
                      className="align-middle"
                    >
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Venta</th>
                          <th>Sede</th>
                          <th>Vendedor</th>
                          <th>Producto</th>
                          <th className="text-center">
                            Cant.
                          </th>
                          <th className="text-end">
                            Comisión
                          </th>
                          <th className="text-center">
                            Liquidada
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {comisionesValidadas.length ===
                        0 ? (
                          <tr>
                            <td
                              colSpan={8}
                              className="text-center text-muted py-4"
                            >
                              No hay comisiones
                              validadas para mostrar.
                            </td>
                          </tr>
                        ) : (
                          comisionesValidadas.map(
                            (item) => {
                              const vendedor =
                                [
                                  item?.vendedor
                                    ?.nombres,
                                  item?.vendedor
                                    ?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                item?.vendedor
                                  ?.email ||
                                "-";
                              return (
                                <tr
                                  key={
                                    item._id
                                  }
                                >
                                  <td>
                                    {fechaInput(
                                      item.fechaVenta
                                    )}
                                  </td>
                                  <td className="fw-bold">
                                    N°{" "}
                                    {item.nroventa}
                                  </td>
                                  <td>
                                    {item.sede}
                                  </td>
                                  <td>
                                    {vendedor}
                                  </td>
                                  <td>
                                    <div className="fw-semibold">
                                      {item.codprod} -{" "}
                                      {item.descripcionProducto ||
                                        item.modeloProducto ||
                                        "-"}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {Number(
                                      item.cantidad ||
                                        0
                                    )}
                                  </td>
                                  <td className="text-end fw-bold text-success">
                                    USD{" "}
                                    {formatoUSD(
                                      item.comisionTotalUSD
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      bg={
                                        item.liquidada
                                          ? "success"
                                          : "warning"
                                      }
                                    >
                                      {item.liquidada
                                        ? "Sí"
                                        : "Pendiente"}
                                    </Badge>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </Tab>
                <Tab
                  eventKey="resumen-semanal"
                  title="Resumen semanal"
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <h6 className="fw-bold mb-1">
                        Pre-liquidación semanal
                      </h6>
                      <div className="small text-muted">
                        Semana de lunes a domingo.
                        Solo incluye comisiones validadas
                        todavía no liquidadas.
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        cargarResumenSemanal({
                          sede: sedeResumenSemanal,
                          desde: periodoSeleccionado.desde,
                          hasta: periodoSeleccionado.hasta,
                        })
                      }
                      disabled={
                        cargandoResumenSemanal
                      }
                    >
                      <FiRefreshCw className="me-1" />
                      Actualizar
                    </Button>
                  </div>
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Semana
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            fechaReferenciaSemanal
                          }
                          onChange={(e) =>
                            setFechaReferenciaSemanal(
                              e.target.value
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            sedeResumenSemanal
                          }
                          onChange={(e) =>
                            setSedeResumenSemanal(
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map((sede) => (
                            <option
                              key={sede.value}
                              value={sede.value}
                            >
                              {sede.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      className="d-flex align-items-end"
                    >
                      <div className="border rounded px-3 py-2 w-100">
                        <span className="text-muted me-2">
                          Período:
                        </span>
                        <strong>
                          {periodoSemanal.desde || "-"}
                          {" → "}
                          {periodoSemanal.hasta || "-"}
                        </strong>
                        <Badge
                          bg={
                            semanaFinalizada
                              ? "success"
                              : "warning"
                          }
                          className="ms-2"
                        >
                          {semanaFinalizada
                            ? "Cerrable"
                            : "Semana abierta"}
                        </Badge>
                      </div>
                    </Col>
                  </Row>
                  {/* TOTALES */}
                  <Row className="g-2 mb-3">
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Vendedores
                          </div>
                          <div className="fs-5 fw-bold">
                            {totalesSemanales
                              .cantidadVendedores}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Ventas
                          </div>
                          <div className="fs-5 fw-bold">
                            {totalesSemanales
                              .cantidadVentas}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Productos
                          </div>
                          <div className="fs-5 fw-bold">
                            {totalesSemanales
                              .cantidadProductos}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Comisiones
                          </div>
                          <div className="fw-bold">
                            USD{" "}
                            {formatoUSD(
                              totalesSemanales
                                .comisionProductosUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Bonos
                          </div>
                          <div className="fw-bold">
                            USD{" "}
                            {formatoUSD(
                              totalesSemanales
                                .bonosSemanalesUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={2}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Total semana
                          </div>
                          <div className="fw-bold text-success">
                            USD{" "}
                            {formatoUSD(
                              totalesSemanales
                                .totalSemanaUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {cargandoResumenSemanal ? (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Calculando semana...
                    </div>
                  ) : (
                    <Table
                      responsive
                      hover
                      className="align-middle"
                    >
                      <thead>
                        <tr>
                          <th>Vendedor</th>
                          <th>Sede</th>
                          <th className="text-center">
                            Ventas
                          </th>
                          <th className="text-center">
                            Productos
                          </th>
                          <th className="text-end">
                            Comisiones
                          </th>
                          <th className="text-end">
                            Bono semanal
                          </th>
                          <th className="text-end">
                            Total
                          </th>
                          <th className="text-center">
                            Estado
                          </th>
                          <th className="text-end">
                            Acción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumenSemanal.length ===
                        0 ? (
                          <tr>
                            <td
                              colSpan={9}
                              className="text-center text-muted py-4"
                            >
                              No hay comisiones pendientes
                              para esta semana.
                            </td>
                          </tr>
                        ) : (
                          resumenSemanal.map(
                            (item) => {
                              const vendedor =
                                [
                                  item?.vendedor
                                    ?.nombres,
                                  item?.vendedor
                                    ?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                item?.vendedor
                                  ?.email ||
                                "-";
                              return (
                                <tr
                                  key={`${item.vendedorId}-${item.sede}`}
                                >
                                  <td className="fw-semibold">
                                    {vendedor}
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        item.sede ===
                                        "MIAMI"
                                          ? "primary"
                                          : "secondary"
                                      }
                                    >
                                      {item.sede}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    {Number(
                                      item.cantidadVentas ||
                                        0
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {Number(
                                      item.cantidadProductos ||
                                        0
                                    )}
                                  </td>
                                  <td className="text-end">
                                    USD{" "}
                                    {formatoUSD(
                                      item.comisionProductosUSD
                                    )}
                                  </td>
                                  <td className="text-end">
                                    USD{" "}
                                    {formatoUSD(
                                      item.bonoSemanalUSD
                                    )}
                                    {item.tramoBono && (
                                      <div className="small text-muted">
                                        Tramo{" "}
                                        {
                                          item.tramoBono
                                            .cantidad
                                        }
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-end fw-bold text-success">
                                    USD{" "}
                                    {formatoUSD(
                                      item.totalSemanaUSD
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.requiereRevisionConfiguracion ? (
                                      <Badge bg="danger">
                                        Revisar
                                      </Badge>
                                    ) : (
                                      <Badge bg="success">
                                        OK
                                      </Badge>
                                    )}
                                  </td>
                                  <td className="text-end">
                                    <Button
                                      size="sm"
                                      variant={
                                        semanaFinalizada
                                          ? "outline-success"
                                          : "outline-secondary"
                                      }
                                      disabled={
                                        !semanaFinalizada ||
                                        item.requiereRevisionConfiguracion ||
                                        cerrandoLiquidacionKey ===
                                          `${item.vendedorId}-${item.sede}`
                                      }
                                      onClick={() =>
                                        cerrarSemanaVendedor(
                                          item
                                        )
                                      }
                                    >
                                      {cerrandoLiquidacionKey ===
                                      `${item.vendedorId}-${item.sede}` ? (
                                        <Spinner
                                          animation="border"
                                          size="sm"
                                        />
                                      ) : semanaFinalizada ? (
                                        "Cerrar semana"
                                      ) : (
                                        "Semana abierta"
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                  <Alert
                    variant="info"
                    className="py-2 mt-3 mb-0"
                  >
                    <strong>
                      Liquidación semanal:
                    </strong>{" "}
                    cerrar una semana genera la liquidación real
                    y marca sus comisiones como liquidadas.
                    El cierre todavía no registra el pago al vendedor.
                  </Alert>
                </Tab>
                <Tab
                  eventKey="resumen-mensual"
                  title="Resumen mensual"
                >
                  <div className="mb-3">
                    <h6 className="fw-bold mb-1">
                      Bono mensual
                    </h6>
                    <div className="small text-muted">
                      Ciclo de 4 semanas completas.
                      Excepcionalmente puede utilizarse un
                      ciclo de 5 semanas.
                    </div>
                  </div>
                  <Row className="g-2 mb-3">
                    <Col
                      xs={12}
                      md={3}
                    >
                      <Form.Group>
                        <Form.Label>
                          Inicio del ciclo
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            fechaInicioResumenMensual
                          }
                          onChange={(e) =>
                            setFechaInicioResumenMensual(
                              e.target.value
                            )
                          }
                        />
                        <Form.Text muted>
                          Debe ser lunes.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={2}
                    >
                      <Form.Group>
                        <Form.Label>
                          Semanas
                        </Form.Label>
                        <Form.Select
                          value={
                            semanasResumenMensual
                          }
                          onChange={(e) =>
                            setSemanasResumenMensual(
                              Number(
                                e.target.value
                              )
                            )
                          }
                        >
                          <option value={4}>
                            4 semanas
                          </option>
                          <option value={5}>
                            5 semanas
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={3}
                    >
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            sedeResumenMensual
                          }
                          onChange={(e) =>
                            setSedeResumenMensual(
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map(
                            (sede) => (
                              <option
                                key={sede.value}
                                value={sede.value}
                              >
                                {sede.label}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                      className="d-flex align-items-end gap-2"
                    >
                      <Button
                        variant="primary"
                        className="w-100"
                        onClick={
                          consultarResumenMensual
                        }
                        disabled={
                          cargandoResumenMensual ||
                          cerrandoCicloMensual
                        }
                      >
                        {cargandoResumenMensual ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            Consultando...
                          </>
                        ) : (
                          <>
                            <FiRefreshCw className="me-2" />
                            Consultar ciclo
                          </>
                        )}
                      </Button>
                      <Button
                        variant="success"
                        className="w-100"
                        onClick={
                          cerrarCicloMensual
                        }
                        disabled={
                          cargandoResumenMensual ||
                          cerrandoCicloMensual ||
                          !sedeResumenMensual ||
                          !periodoMensualResumen.desde
                        }
                      >
                        {cerrandoCicloMensual ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            Cerrando...
                          </>
                        ) : (
                          <>
                            <FiCheckCircle className="me-2" />
                            Cerrar ciclo
                          </>
                        )}
                      </Button>
                    </Col>
                  </Row>
                  {periodoMensualResumen.desde && (
                    <Alert
                      variant="info"
                      className="py-2"
                    >
                      Período consultado:{" "}
                      <strong>
                        {periodoMensualResumen.desde}
                        {" → "}
                        {periodoMensualResumen.hasta}
                      </strong>
                      {" · "}
                      {periodoMensualResumen.semanas}{" "}
                      semanas
                    </Alert>
                  )}
                  {periodoMensualResumen.desde && (
                    <Row className="g-2 mb-3">
                      <Col
                        xs={6}
                        md={3}
                      >
                        <Card className="h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Vendedores
                            </div>
                            <div className="fs-5 fw-bold">
                              {
                                totalesMensuales
                                  .cantidadVendedores
                              }
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={6}
                        md={3}
                      >
                        <Card className="h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Ventas
                            </div>
                            <div className="fs-5 fw-bold">
                              {
                                totalesMensuales
                                  .cantidadVentas
                              }
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={6}
                        md={3}
                      >
                        <Card className="h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Productos
                            </div>
                            <div className="fs-5 fw-bold">
                              {
                                totalesMensuales
                                  .cantidadProductos
                              }
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={6}
                        md={3}
                      >
                        <Card className="h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Bonos mensuales
                            </div>
                            <div className="fs-5 fw-bold">
                              {formatoUSD(
                                totalesMensuales
                                  .bonosMensualesUSD
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  )}
                  {periodoMensualResumen.desde && (
                    <>
                      {cargandoResumenMensual ? (
                        <div className="text-center py-5">
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Calculando ciclo mensual...
                        </div>
                      ) : (
                        <Table
                          responsive
                          hover
                          className="align-middle"
                        >
                          <thead>
                            <tr>
                              <th>Vendedor</th>
                              <th>Sede</th>
                              <th className="text-center">
                                Ventas
                              </th>
                              <th className="text-center">
                                Productos
                              </th>
                              <th className="text-center">
                                Regla
                              </th>
                              <th className="text-center">
                                Tramo / Puesto
                              </th>
                              <th className="text-end">
                                Bono mensual
                              </th>
                              <th className="text-center">
                                Estado
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {resumenMensual.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={8}
                                  className="text-center text-muted py-4"
                                >
                                  No hay comisiones validadas
                                  para este ciclo.
                                </td>
                              </tr>
                            ) : (
                              resumenMensual.map(
                                (item) => {
                                  const vendedor =
                                    [
                                      item?.vendedor
                                        ?.nombres,
                                      item?.vendedor
                                        ?.apellidos,
                                    ]
                                      .filter(Boolean)
                                      .join(" ") ||
                                    item?.vendedor
                                      ?.email ||
                                    "-";
                                  return (
                                    <tr
                                      key={`${item.vendedorId}-${item.sede}`}
                                    >
                                      <td className="fw-semibold">
                                        {vendedor}
                                      </td>
                                      <td>
                                        <Badge
                                          bg={
                                            item.sede ===
                                            "MIAMI"
                                              ? "primary"
                                              : "secondary"
                                          }
                                        >
                                          {item.sede}
                                        </Badge>
                                      </td>
                                      <td className="text-center">
                                        {Number(
                                          item.cantidadVentas ||
                                            0
                                        )}
                                      </td>
                                      <td className="text-center fw-bold">
                                        {Number(
                                          item.cantidadProductos ||
                                            0
                                        )}
                                      </td>
                                      <td className="text-center">
                                        <Badge
                                          bg={
                                            item.tipoBonoMensual ===
                                            "RANKING"
                                              ? "info"
                                              : item.tipoBonoMensual ===
                                                "CANTIDAD"
                                              ? "primary"
                                              : "secondary"
                                          }
                                        >
                                          {item.tipoBonoMensual ||
                                            "NINGUNO"}
                                        </Badge>
                                      </td>
                                      <td className="text-center">
                                        {item.tipoBonoMensual ===
                                        "RANKING" ? (
                                          item.puestoRanking ? (
                                            <strong>
                                              {item.puestoRanking}°
                                            </strong>
                                          ) : (
                                            "—"
                                          )
                                        ) : item.tramoBonoMensual ? (
                                          <>
                                            {
                                              item
                                                .tramoBonoMensual
                                                .cantidad
                                            }{" "}
                                            productos
                                          </>
                                        ) : (
                                          "—"
                                        )}
                                      </td>
                                      <td className="text-end fw-bold text-success">
                                        USD{" "}
                                        {formatoUSD(
                                          item.bonoMensualUSD
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {item.requiereRevisionConfiguracion ? (
                                          <Badge bg="danger">
                                            Revisar
                                          </Badge>
                                        ) : (
                                          <Badge bg="success">
                                            OK
                                          </Badge>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            )}
                          </tbody>
                        </Table>
                      )}
                    </>
                  )}
                </Tab>
                <Tab
                  eventKey="liquidaciones"
                  title="Liquidaciones"
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <h6 className="fw-bold mb-1">
                        Liquidaciones cerradas
                      </h6>
                      <div className="small text-muted">
                        Historial de liquidaciones generadas
                        por vendedor y período.
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        cargarLiquidaciones(
                          filtrosLiquidaciones
                        )
                      }
                      disabled={
                        cargandoLiquidaciones
                      }
                    >
                      <FiRefreshCw className="me-1" />
                      Actualizar
                    </Button>
                  </div>
                  {/* FILTROS */}
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Desde
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosLiquidaciones.desde
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                desde:
                                  e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Hasta
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosLiquidaciones.hasta
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                hasta:
                                  e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosLiquidaciones.sede
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                sede:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map((sede) => (
                            <option
                              key={sede.value}
                              value={sede.value}
                            >
                              {sede.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Vendedor
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosLiquidaciones.vendedor
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                vendedor:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todos
                          </option>
                          {vendedoresLiquidaciones.map(
                            (vendedor) => (
                              <option
                                key={vendedor.id}
                                value={vendedor.id}
                              >
                                {vendedor.nombre}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Tipo
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosLiquidaciones.tipo
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                tipo: e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todos
                          </option>
                          <option value="SEMANAL">
                            Semanal
                          </option>
                          <option value="MENSUAL">
                            Mensual
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Estado
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosLiquidaciones.estado
                          }
                          onChange={(e) =>
                            setFiltrosLiquidaciones(
                              (prev) => ({
                                ...prev,
                                estado:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todos
                          </option>
                          <option value="PENDIENTE_PAGO">
                            Pendiente de pago
                          </option>
                          <option value="PARCIAL">
                            Pago parcial
                          </option>
                          <option value="PAGADA">
                            Pagada
                          </option>
                          <option value="ANULADA">
                            Anulada
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex gap-2 mb-3">
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() =>
                        cargarLiquidaciones(
                          filtrosLiquidaciones
                        )
                      }
                      disabled={
                        cargandoLiquidaciones
                      }
                    >
                      Aplicar
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => {
                        const vacios = {
                          sede: "",
                          vendedor: "",
                          tipo: "",
                          estado: "",
                          desde: "",
                          hasta: "",
                        };
                        setFiltrosLiquidaciones(
                          vacios
                        );
                        cargarLiquidaciones(
                          vacios
                        );
                      }}
                      disabled={
                        cargandoLiquidaciones
                      }
                    >
                      Limpiar
                    </Button>
                  </div>
                  {/* RESUMEN */}
                  <Row className="g-2 mb-3">
                    <Col xs={6} md={3}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Liquidaciones
                          </div>
                          <div className="fs-5 fw-bold">
                            {Number(
                              resumenLiquidaciones
                                .cantidad || 0
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={3}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Total liquidado
                          </div>
                          <div className="fw-bold">
                            USD{" "}
                            {formatoUSD(
                              resumenLiquidaciones
                                .totalLiquidadoUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={3}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Pagado
                          </div>
                          <div className="fw-bold text-success">
                            USD{" "}
                            {formatoUSD(
                              resumenLiquidaciones
                                .totalPagadoUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={6} md={3}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            TOTAL A DISPONER
                          </div>
                          <div className="fs-5 fw-bold text-danger">
                            USD{" "}
                            {formatoUSD(
                              resumenLiquidaciones
                                .saldoPendienteUSD
                            )}
                          </div>
                          <div className="small text-muted mt-1">
                            Pendiente de pago según filtros
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {/* TABLA */}
                  {cargandoLiquidaciones ? (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Cargando liquidaciones...
                    </div>
                  ) : (
                    <Table
                      responsive
                      hover
                      className="align-middle"
                    >
                      <thead>
                        <tr>
                          <th>Vendedor</th>
                          <th>Sede</th>
                          <th>Tipo</th>
                          <th>Período</th>
                          <th className="text-center">
                            Productos
                          </th>
                          <th className="text-end">
                            Comisión
                          </th>
                          <th className="text-end">
                            Bono
                          </th>
                          <th className="text-end">
                            Total
                          </th>
                          <th className="text-end">
                            Pagado
                          </th>
                          <th className="text-end">
                            Saldo
                          </th>
                          <th className="text-center">
                            Estado
                          </th>
                          <th className="text-end">
                            Acción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {liquidacionesComision.length ===
                        0 ? (
                          <tr>
                            <td
                              colSpan={12}
                              className="text-center text-muted py-4"
                            >
                              Todavía no hay liquidaciones
                              para mostrar.
                            </td>
                          </tr>
                        ) : (
                          liquidacionesComision.map(
                            (item) => {
                              const vendedor =
                                [
                                  item?.vendedor
                                    ?.nombres,
                                  item?.vendedor
                                    ?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                item?.vendedor
                                  ?.email ||
                                "-";
                              const estado =
                                String(
                                  item.estado || ""
                                ).toUpperCase();
                              let colorEstado =
                                "secondary";
                              let textoEstado =
                                estado || "-";
                              if (
                                estado ===
                                "PENDIENTE_PAGO"
                              ) {
                                colorEstado =
                                  "warning";
                                textoEstado =
                                  "Pendiente";
                              }
                              if (
                                estado ===
                                "PARCIAL"
                              ) {
                                colorEstado =
                                  "info";
                                textoEstado =
                                  "Parcial";
                              }
                              if (
                                estado ===
                                "PAGADA"
                              ) {
                                colorEstado =
                                  "success";
                                textoEstado =
                                  "Pagada";
                              }
                              if (
                                estado ===
                                "ANULADA"
                              ) {
                                colorEstado =
                                  "danger";
                                textoEstado =
                                  "Anulada";
                              }
                              return (
                                <tr
                                  key={item._id}
                                >
                                  <td className="fw-semibold">
                                    {vendedor}
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        item.sede ===
                                        "MIAMI"
                                          ? "primary"
                                          : "secondary"
                                      }
                                    >
                                      {item.sede}
                                    </Badge>
                                  </td>
                                 <td className="text-center">
                                  <Badge
                                    bg={
                                      item.tipo === "MENSUAL"
                                        ? "info"
                                        : "secondary"
                                    }
                                  >
                                    {item.tipo === "MENSUAL"
                                      ? "Mensual"
                                      : "Semanal"}
                                  </Badge>
                                </td> 
                                  <td>
                                    {fechaInput(
                                      item.periodoDesde
                                    )}
                                    {" → "}
                                    {fechaInput(
                                      item.periodoHasta
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {Number(
                                      item.cantidadProductos ||
                                        0
                                    )}
                                  </td>
                                  <td className="text-end">
                                    USD{" "}
                                    {formatoUSD(
                                      item.comisionProductosUSD
                                    )}
                                  </td>
                                  <td className="text-end">
                                    USD{" "}
                                    {formatoUSD(
                                      item.tipo === "MENSUAL"
                                        ? item.bonoMensualUSD
                                        : item.bonoSemanalUSD
                                    )}
                                  </td>
                                  <td className="text-end fw-bold">
                                    USD{" "}
                                    {formatoUSD(
                                      item.totalLiquidacionUSD
                                    )}
                                  </td>
                                  <td className="text-end text-success">
                                    USD{" "}
                                    {formatoUSD(
                                      item.totalPagadoUSD
                                    )}
                                  </td>
                                  <td className="text-end fw-bold">
                                    USD{" "}
                                    {formatoUSD(
                                      item.saldoPendienteUSD
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      bg={colorEstado}
                                    >
                                      {textoEstado}
                                    </Badge>
                                  </td>
                                  <td className="text-end">
                                    <div className="d-flex justify-content-end gap-2">
                                      <Button
                                        size="sm"
                                        variant="outline-primary"
                                        onClick={() =>
                                          abrirCuentaCorriente(
                                            item
                                          )
                                        }
                                      >
                                        Cuenta cte.
                                      </Button>
                                      {(
                                        estado ===
                                          "PENDIENTE_PAGO" ||
                                        estado ===
                                          "PARCIAL"
                                      ) &&
                                      Number(
                                        item.saldoPendienteUSD ||
                                          0
                                      ) > 0 && (
                                        <Button
                                          size="sm"
                                          variant="outline-success"
                                          onClick={() =>
                                            abrirPagoLiquidacion(
                                              item
                                            )
                                          }
                                        >
                                          <FiDollarSign className="me-1" />
                                          Pagar
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                  <Alert
                    variant="info"
                    className="py-2 mt-3 mb-0"
                  >
                    <strong>
                      Liquidaciones:
                    </strong>{" "}
                    desde esta pantalla se pueden registrar
                    pagos parciales o totales sobre las
                    liquidaciones pendientes.
                  </Alert>
                </Tab>
                <Tab
                  eventKey="pagos"
                  title="Pagos"
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <h6 className="fw-bold mb-1">
                        Historial de pagos
                      </h6>
                      <div className="small text-muted">
                        Pagos registrados sobre
                        liquidaciones de comisiones.
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        cargarPagos(
                          filtrosPagos
                        )
                      }
                      disabled={
                        cargandoPagos
                      }
                    >
                      <FiRefreshCw className="me-1" />
                      Actualizar
                    </Button>
                  </div>
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Desde
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosPagos.desde
                          }
                          onChange={(e) =>
                            setFiltrosPagos(
                              (prev) => ({
                                ...prev,
                                desde:
                                  e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Hasta
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosPagos.hasta
                          }
                          onChange={(e) =>
                            setFiltrosPagos(
                              (prev) => ({
                                ...prev,
                                hasta:
                                  e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosPagos.sede
                          }
                          onChange={(e) =>
                            setFiltrosPagos(
                              (prev) => ({
                                ...prev,
                                sede:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map(
                            (sede) => (
                              <option
                                key={
                                  sede.value
                                }
                                value={
                                  sede.value
                                }
                              >
                                {sede.label}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Estado
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosPagos.estado
                          }
                          onChange={(e) =>
                            setFiltrosPagos(
                              (prev) => ({
                                ...prev,
                                estado:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todos
                          </option>
                          <option value="ACTIVO">
                            Activos
                          </option>
                          <option value="ANULADO">
                            Anulados
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex gap-2 mb-3">
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() =>
                        cargarPagos(
                          filtrosPagos
                        )
                      }
                      disabled={
                        cargandoPagos
                      }
                    >
                      Aplicar
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => {
                        const vacios = {
                          sede: "",
                          estado: "",
                          desde: "",
                          hasta: "",
                        };
                        setFiltrosPagos(
                          vacios
                        );
                        cargarPagos(
                          vacios
                        );
                      }}
                      disabled={
                        cargandoPagos
                      }
                    >
                      Limpiar
                    </Button>
                  </div>
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={6}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Cantidad de pagos
                          </div>
                          <div className="fs-5 fw-bold">
                            {Number(
                              resumenPagos
                                .cantidadPagos ||
                                0
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col xs={12} md={6}>
                      <Card className="border h-100">
                        <Card.Body className="py-2">
                          <div className="small text-muted">
                            Total pagado
                          </div>
                          <div className="fs-5 fw-bold text-success">
                            USD{" "}
                            {formatoUSD(
                              resumenPagos
                                .totalPagadoUSD
                            )}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {/* TABLA DE PAGOS */}
                  {cargandoPagos ? (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Cargando pagos...
                    </div>
                  ) : (
                    <Table
                      responsive
                      hover
                      className="align-middle"
                    >
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Vendedor</th>
                          <th>Sede</th>
                          <th>Tipo</th>
                          <th>Período</th>
                          <th className="text-end">
                            Monto
                          </th>
                          <th>Referencia</th>
                          <th>Registrado por</th>
                          <th className="text-center">
                            Estado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pagosComision.length === 0 ? (
                          <tr>
                            <td
                              colSpan={9}
                              className="text-center text-muted py-4"
                            >
                              No hay pagos registrados
                              para mostrar.
                            </td>
                          </tr>
                        ) : (
                          pagosComision.map(
                            (item) => {
                              const vendedor =
                                [
                                  item?.vendedor?.nombres,
                                  item?.vendedor?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                item?.vendedor?.email ||
                                "-";
                              const registradoPor =
                                [
                                  item?.registradoPor?.nombres,
                                  item?.registradoPor?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                item?.registradoPor?.email ||
                                "-";
                              const estado =
                                String(
                                  item.estado || ""
                                ).toUpperCase();
                              return (
                                <tr key={item._id}>
                                  <td>
                                    {fechaInput(
                                      item.fechaPago
                                    )}
                                  </td>
                                  <td className="fw-semibold">
                                    {vendedor}
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        item.sede === "MIAMI"
                                          ? "primary"
                                          : "secondary"
                                      }
                                    >
                                      {item.sede}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    {item?.liquidacion?.tipo ? (
                                      <Badge
                                        bg={
                                          item.liquidacion.tipo ===
                                          "MENSUAL"
                                            ? "info"
                                            : "secondary"
                                        }
                                      >
                                        {item.liquidacion.tipo ===
                                        "MENSUAL"
                                          ? "Mensual"
                                          : "Semanal"}
                                      </Badge>
                                    ) : (
                                      "—"
                                    )}
                                  </td>
                                  <td>
                                    {item?.liquidacion ? (
                                      <>
                                        {fechaInput(
                                          item.liquidacion
                                            .periodoDesde
                                        )}
                                        {" → "}
                                        {fechaInput(
                                          item.liquidacion
                                            .periodoHasta
                                        )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td className="text-end fw-bold text-success">
                                    USD{" "}
                                    {formatoUSD(
                                      item.montoUSD
                                    )}
                                  </td>
                                  <td>
                                    {item.referencia ||
                                      "—"}
                                  </td>
                                  <td>
                                    {registradoPor}
                                  </td>
                                  <td className="text-center">
                                    <Badge
                                      bg={
                                        estado === "ACTIVO"
                                          ? "success"
                                          : "danger"
                                      }
                                    >
                                      {estado || "-"}
                                    </Badge>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </Tab>
               <Tab
                eventKey="cuenta-corriente"
                title="Cuenta corriente"
              >
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                  <div>
                    <h6 className="fw-bold mb-1">
                      Cuenta corriente del vendedor
                    </h6>
                    <div className="small text-muted">
                      Liquidaciones, pagos y saldo pendiente.
                    </div>
                  </div>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    disabled={
                      cargandoCuentaCorriente ||
                      !vendedorCuentaCorriente
                    }
                    onClick={() =>
                      cargarCuentaCorriente({
                        vendedor:
                          vendedorCuentaCorriente,
                        sede:
                          sedeCuentaCorriente,
                      })
                    }
                  >
                    <FiRefreshCw className="me-1" />
                    Actualizar
                  </Button>
                </div>
                {!vendedorCuentaCorriente ? (
                  <Alert
                    variant="info"
                    className="py-2"
                  >
                    Abrí la cuenta corriente desde una
                    liquidación para seleccionar al vendedor.
                  </Alert>
                ) : (
                  <>
                    <Card className="border mb-3">
                      <Card.Body className="py-2">
                        <Row className="g-2">
                          <Col xs={12} md={8}>
                            <div className="small text-muted">
                              Vendedor
                            </div>
                            <div className="fw-bold">
                              {[
                                vendedorCuentaCorriente
                                  ?.nombres,
                                vendedorCuentaCorriente
                                  ?.apellidos,
                              ]
                                .filter(Boolean)
                                .join(" ") ||
                                vendedorCuentaCorriente
                                  ?.email ||
                                "-"}
                            </div>
                          </Col>
                          <Col xs={12} md={4}>
                            <div className="small text-muted">
                              Sede
                            </div>
                            <div className="fw-bold">
                              {sedeCuentaCorriente ||
                                "Todas"}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <Row className="g-2 mb-3">
                      <Col xs={12} md={4}>
                        <Card className="border h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Total liquidado
                            </div>
                            <div className="fs-5 fw-bold">
                              USD{" "}
                              {formatoUSD(
                                resumenCuentaCorriente
                                  .totalLiquidacionesUSD
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="border h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Total pagado
                            </div>
                            <div className="fs-5 fw-bold text-success">
                              USD{" "}
                              {formatoUSD(
                                resumenCuentaCorriente
                                  .totalPagosUSD
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col xs={12} md={4}>
                        <Card className="border h-100">
                          <Card.Body className="py-2">
                            <div className="small text-muted">
                              Saldo actual
                            </div>
                            <div className="fs-5 fw-bold text-warning">
                              USD{" "}
                              {formatoUSD(
                                resumenCuentaCorriente
                                  .saldoActualUSD
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    {/* MOVIMIENTOS DE CUENTA CORRIENTE */}
                    {cargandoCuentaCorriente ? (
                      <div className="text-center py-4">
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Cargando movimientos...
                      </div>
                    ) : (
                      <Table
                        responsive
                        hover
                        className="align-middle"
                      >
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Origen</th>
                            <th>Detalle</th>
                            <th className="text-end">
                              Monto
                            </th>
                            <th className="text-end">
                              Movimiento
                            </th>
                            <th className="text-end">
                              Saldo
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {movimientosCuentaCorriente.length === 0 ? (
                            <tr>
                              <td
                                colSpan={7}
                                className="text-center text-muted py-4"
                              >
                                No hay movimientos registrados.
                              </td>
                            </tr>
                          ) : (
                            movimientosCuentaCorriente.map(
                              (item) => {
                                const impacto =
                                  Number(
                                    item.impactoSaldoUSD || 0
                                  );
                                return (
                                  <tr key={item._id}>
                                    <td>
                                      {fechaInput(
                                        item.fechaMovimiento
                                      )}
                                    </td>
                                    <td>
                                      <Badge
                                        bg={
                                          item.tipo ===
                                          "LIQUIDACION"
                                            ? "primary"
                                            : item.tipo ===
                                              "PAGO"
                                            ? "success"
                                            : "secondary"
                                        }
                                      >
                                        {item.tipo}
                                      </Badge>
                                    </td>
                                    <td className="text-center">
                                      {item?.liquidacion?.tipo ? (
                                        <Badge
                                          bg={
                                            item.liquidacion.tipo ===
                                            "MENSUAL"
                                              ? "info"
                                              : "secondary"
                                          }
                                        >
                                          {item.liquidacion.tipo ===
                                          "MENSUAL"
                                            ? "Mensual"
                                            : "Semanal"}
                                        </Badge>
                                      ) : (
                                        "—"
                                      )}
                                    </td>
                                    <td>
                                      {item.descripcion ||
                                        "—"}
                                    </td>
                                    <td className="text-end">
                                      USD{" "}
                                      {formatoUSD(
                                        item.montoUSD
                                      )}
                                    </td>
                                    <td
                                      className={`text-end fw-bold ${
                                        impacto >= 0
                                          ? "text-danger"
                                          : "text-success"
                                      }`}
                                    >
                                      {impacto >= 0
                                        ? "+"
                                        : "-"}
                                      {" USD "}
                                      {formatoUSD(
                                        Math.abs(
                                          impacto
                                        )
                                      )}
                                    </td>
                                    <td className="text-end fw-bold">
                                      USD{" "}
                                      {formatoUSD(
                                        item.saldoAcumuladoUSD
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          )}
                        </tbody>
                      </Table>
                    )}
                  </>
                )}
              </Tab> 
                <Tab
                  eventKey="pendientes"
                  title={`Pendientes${
                    pendientesComision.length > 0
                      ? ` (${pendientesComision.length})`
                      : ""
                  }`}
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <div>
                      <h6 className="fw-bold mb-1">
                        Ventas pendientes de validar
                      </h6>
                      <div className="small text-muted">
                        Ventas con saldo cero,
                        dentro de la vigencia de
                        comisiones y todavía no
                        validadas.
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => cargarPendientes(filtrosPendientes)}
                      disabled={cargandoPendientes}
                    >
                      <FiRefreshCw className="me-1" />
                      Actualizar
                    </Button>
                  </div>
                  <Row className="g-2 mb-3">
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Sede
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosPendientes.sede
                          }
                          onChange={(e) =>
                            setFiltrosPendientes(
                              (prev) => ({
                                ...prev,
                                sede: e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todas
                          </option>
                          {SEDES.map((sede) => (
                            <option
                              key={sede.value}
                              value={sede.value}
                            >
                              {sede.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>
                          Vendedor
                        </Form.Label>
                        <Form.Select
                          value={
                            filtrosPendientes.vendedor
                          }
                          onChange={(e) =>
                            setFiltrosPendientes(
                              (prev) => ({
                                ...prev,
                                vendedor:
                                  e.target.value,
                              })
                            )
                          }
                        >
                          <option value="">
                            Todos
                          </option>
                          {Array.from(
                            new Map(
                              pendientesComision
                                .filter(
                                  (venta) =>
                                    venta?.vendedor?._id
                                )
                                .map((venta) => [
                                  venta.vendedor._id,
                                  venta.vendedor,
                                ])
                            ).values()
                          )
                            .sort((a, b) =>
                              `${a?.nombres || ""} ${
                                a?.apellidos || ""
                              }`.localeCompare(
                                `${b?.nombres || ""} ${
                                  b?.apellidos || ""
                                }`
                              )
                            )
                            .map((vendedor) => (
                              <option
                                key={vendedor._id}
                                value={vendedor._id}
                              >
                                {[
                                  vendedor.nombres,
                                  vendedor.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                  vendedor.email}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Desde
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosPendientes.desde
                          }
                          onChange={(e) =>
                            setFiltrosPendientes(
                              (prev) => ({
                                ...prev,
                                desde: e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2}>
                      <Form.Group>
                        <Form.Label>
                          Hasta
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={
                            filtrosPendientes.hasta
                          }
                          onChange={(e) =>
                            setFiltrosPendientes(
                              (prev) => ({
                                ...prev,
                                hasta: e.target.value,
                              })
                            )
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md={2}
                      className="d-flex align-items-end gap-2"
                    >
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() =>
                          cargarPendientes(
                            filtrosPendientes
                          )
                        }
                        disabled={
                          cargandoPendientes
                        }
                      >
                        Aplicar
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => {
                          const vacios = {
                            sede: "",
                            vendedor: "",
                            desde: "",
                            hasta: "",
                          };
                          setFiltrosPendientes(
                            vacios
                          );
                          cargarPendientes(
                            vacios
                          );
                        }}
                        disabled={
                          cargandoPendientes
                        }
                      >
                        Limpiar
                      </Button>
                    </Col>
                  </Row>
                  <Alert variant="info" className="mb-3">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <div>
                        <div className="fw-bold">Comisiones estimadas pendientes de validar</div>
                        <div className="small">{pendientesComision.length} ventas según los filtros aplicados.</div>
                      </div>
                      <div className="fs-4 fw-bold">
                        {cargandoPendientes || estimacionPendientes.calculando ? (
                          <><Spinner animation="border" size="sm" className="me-2" />Calculando...</>
                        ) : (
                          <>{resumenEstimacionPendientes.errores > 0 ? "Subtotal: " : "Total: "}USD {formatoUSD(resumenEstimacionPendientes.totalUSD)}</>
                        )}
                      </div>
                    </div>
                    <div className="small mt-2">
                      Previsión de dinero para comisiones por productos. No incluye bonos semanales ni mensuales,
                      ni liquidaciones anteriores pendientes de pago. No valida ni genera pagos.
                    </div>
                    {estimacionPendientes.calculando && (
                      <div className="small mt-1">Procesadas {Object.keys(estimacionPendientes.porVenta).length} de {pendientesComision.length} ventas.</div>
                    )}
                    {!cargandoPendientes && !estimacionPendientes.calculando && resumenEstimacionPendientes.errores > 0 && (
                      <div className="text-danger fw-bold small mt-2">
                        Estimación incompleta: {resumenEstimacionPendientes.calculadas} ventas calculadas y {resumenEstimacionPendientes.errores} sin importe.
                        El subtotal no representa todo lo necesario. Presioná Actualizar para reintentar.
                      </div>
                    )}
                  </Alert>
                  {cargandoPendientes ? (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Cargando pendientes...
                    </div>
                  ) : (
                    <Table
                      responsive
                      hover
                      className="align-middle"
                    >
                      <thead>
                        <tr>
                          <th>Venta</th>
                          <th>Fecha</th>
                          <th>Sede</th>
                          <th>Vendedor</th>
                          <th>Productos</th>
                          <th className="text-center">
                            Cant.
                          </th>
                          <th className="text-end">Comisión estimada USD</th>
                          <th className="text-end">
                            Acción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendientesComision.length ===
                        0 ? (
                          <tr>
                            <td
                              colSpan={8}
                              className="text-center text-muted py-4"
                            >
                              No hay ventas pendientes
                              de validar.
                            </td>
                          </tr>
                        ) : (
                          pendientesComision.map(
                            (venta) => {
                              const vendedor =
                                [
                                  venta?.vendedor?.nombres,
                                  venta?.vendedor?.apellidos,
                                ]
                                  .filter(Boolean)
                                  .join(" ") ||
                                venta?.vendedor?.email ||
                                "-";
                              return (
                                <tr
                                  key={
                                    venta.id ||
                                    venta.nroventa
                                  }
                                >
                                  <td className="fw-bold">
                                    N° {venta.nroventa}
                                  </td>
                                  <td>
                                    {fechaInput(
                                      venta.fecha
                                    )}
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        venta.sede ===
                                        "MIAMI"
                                          ? "primary"
                                          : "secondary"
                                      }
                                    >
                                      {venta.sede}
                                    </Badge>
                                  </td>
                                  <td>
                                    {vendedor}
                                  </td>
                                  <td>
                                    {Array.isArray(
                                      venta.productos
                                    ) &&
                                    venta.productos.length >
                                      0
                                      ? venta.productos
                                          .map(
                                            (producto) =>
                                              `${producto.codprod} - ${producto.descripcion}`
                                          )
                                          .join(" · ")
                                      : "-"}
                                  </td>
                                  <td className="text-center">
                                    {Number(
                                      venta.cantidadProductos ||
                                        0
                                    )}
                                  </td>
                                  <td className="text-end text-nowrap">
                                    {estimacionPendientes.porVenta[venta.nroventa]?.ok ? (
                                      formatoUSD(estimacionPendientes.porVenta[venta.nroventa].montoUSD)
                                    ) : estimacionPendientes.porVenta[venta.nroventa] ? (
                                      <span className="text-danger" title={estimacionPendientes.porVenta[venta.nroventa].error}>Sin estimar</span>
                                    ) : estimacionPendientes.calculando ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : "—"}
                                  </td>
                                  <td className="text-end">
                                    <Button
                                      size="sm"
                                      variant="outline-primary"
                                      onClick={() =>
                                        verPendiente(
                                          venta
                                        )
                                      }
                                    >
                                      Ver
                                    </Button>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </Tab>
                <Tab
                  eventKey="preview"
                  title="Vista previa"
                >
                <Alert
                  variant="warning"
                  className="py-2"
                >
                  <strong>
                    VISTA PREVIA
                  </strong>
                  {" — "}
                  el botón Calcular solo simula y
                  no guarda información. El botón
                  Validar comisión sí genera los
                  registros reales de comisión.
                </Alert>
                  <Row className="g-2 align-items-end mb-3">
                    <Col
                      xs={12}
                      md={4}
                    >
                      <Form.Group>
                        <Form.Label>
                          N° de Venta
                        </Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          placeholder="Ej: 571"
                          value={nroVentaPreview}
                          onChange={(e) =>
                            setNroVentaPreview(
                              e.target.value
                            )
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter"
                            ) {
                              calcularPreview();
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      xs={12}
                      md="auto"
                    >
                      <Button
                        variant="primary"
                        onClick={calcularPreview}
                        disabled={cargandoPreview}
                      >
                        {cargandoPreview ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            Calculando...
                          </>
                        ) : (
                          <>
                            <FiDollarSign className="me-2" />
                            Calcular
                          </>
                        )}
                      </Button>
                    </Col>
                    {previewComision && (
                      <Col
                        xs={12}
                        md="auto"
                      >
                        <Button
                          variant="success"
                          onClick={validarPreview}
                          disabled={
                            validandoComision ||
                            previewComision?.guardado
                          }
                        >
                          {validandoComision ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                              />
                              Validando...
                            </>
                          ) : (
                            <>
                              <FiCheckCircle className="me-2" />
                              {previewComision?.guardado
                                ? "Comisión validada"
                                : "Validar comisión"}
                            </>
                          )}
                        </Button>
                      </Col>
                    )}
                  </Row>
                  {previewComision && (
                    <>
                      <Card className="border mb-3">
                        <Card.Body>
                          <Row className="g-3">
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Venta
                              </div>
                              <div className="fw-bold">
                                N°{" "}
                                {previewComision
                                  ?.venta
                                  ?.nroventa}
                              </div>
                            </Col>
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Sede
                              </div>
                              <div className="fw-bold">
                                {previewComision
                                  ?.venta
                                  ?.sede ||
                                  "-"}
                              </div>
                            </Col>
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Fecha venta
                              </div>
                              <div className="fw-bold">
                                {fechaInput(
                                  previewComision
                                    ?.venta
                                    ?.fecha
                                ) || "-"}
                              </div>
                            </Col>
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Guardado
                              </div>
                              <Badge
                                bg={
                                  previewComision?.guardado
                                    ? "success"
                                    : "secondary"
                                }
                              >
                                {previewComision?.guardado
                                  ? "Sí — Validada"
                                  : "NO — Preview"}
                              </Badge>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <Card className="border mb-3">
                        <Card.Body>
                          <h6 className="fw-bold mb-3">
                            Regla utilizada
                          </h6>
                          <Row className="g-3">
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Progresiva
                              </div>
                              <strong>
                                {previewComision
                                  ?.configuracion
                                  ?.aplicaReglaProgresiva
                                  ? "Sí"
                                  : "No"}
                              </strong>
                            </Col>
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Tramo
                              </div>
                              <strong>
                                USD{" "}
                                {Number(
                                  previewComision
                                    ?.configuracion
                                    ?.tramoPrecioUSD ||
                                    0
                                ).toLocaleString(
                                  "en-US"
                                )}
                              </strong>
                            </Col>
                            <Col
                              xs={6}
                              md={3}
                            >
                              <div className="small text-muted">
                                Variación
                              </div>
                              <strong>
                                {Number(
                                  previewComision
                                    ?.configuracion
                                    ?.porcentajeVariacion ||
                                    0
                                )}
                                %
                              </strong>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                      <Card className="border">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                            <div>
                              <h6 className="fw-bold mb-1">
                                Resultado del cálculo
                              </h6>
                              <div className="small text-muted">
                                Detalle de la comisión calculada
                                para cada producto de la venta.
                              </div>
                            </div>
                            <div className="text-end">
                              <div className="small text-muted">
                                Total comisión
                              </div>
                              <div className="fs-5 fw-bold text-success">
                                USD{" "}
                                {formatoUSD(
                                  previewComision
                                    ?.resultado
                                    ?.totalComisionUSD
                                )}
                              </div>
                            </div>
                          </div>
                          <Table
                            responsive
                            hover
                            className="align-middle mb-3"
                          >
                            <thead>
                              <tr>
                                <th>Cód.</th>
                                <th>Producto</th>
                                <th className="text-center">
                                  Cant.
                                </th>
                                <th className="text-end">
                                  Lista
                                </th>
                                <th className="text-end">
                                  Vendido
                                </th>
                                <th className="text-end">
                                  Diferencia
                                </th>
                                <th className="text-end">
                                  Base
                                </th>
                                <th className="text-end">
                                  Ajuste
                                </th>
                                <th className="text-end">
                                  Comisión
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(
                                previewComision
                                  ?.resultado
                                  ?.items
                              ) &&
                              previewComision.resultado.items
                                .length > 0 ? (
                                previewComision.resultado.items.map(
                                  (item, indice) => (
                                    <tr
                                      key={
                                        item.itemVentaId ||
                                        indice
                                      }
                                    >
                                      <td>
                                        {item.codprod || "-"}
                                      </td>
                                      <td>
                                        <div className="fw-semibold">
                                          {item.descripcionProducto ||
                                            "Sin descripción"}
                                        </div>
                                        {!item.comisiona && (
                                          <div className="small text-danger">
                                            No comisionable
                                            {item.motivo
                                              ? ` — ${item.motivo}`
                                              : ""}
                                          </div>
                                        )}
                                      </td>
                                      <td className="text-center">
                                        {Number(
                                          item.cantidad || 0
                                        )}
                                      </td>
                                      <td className="text-end">
                                        USD{" "}
                                        {formatoUSD(
                                          item.precioListaUSD
                                        )}
                                      </td>
                                      <td className="text-end">
                                        USD{" "}
                                        {formatoUSD(
                                          item.precioVentaUSD
                                        )}
                                      </td>
                                      <td
                                        className={`text-end fw-semibold ${
                                          Number(
                                            item.diferenciaPrecioUSD
                                          ) > 0
                                            ? "text-success"
                                            : Number(
                                                item.diferenciaPrecioUSD
                                              ) < 0
                                            ? "text-danger"
                                            : ""
                                        }`}
                                      >
                                        {Number(
                                          item.diferenciaPrecioUSD
                                        ) > 0
                                          ? "+"
                                          : ""}
                                        USD{" "}
                                        {formatoUSD(
                                          item.diferenciaPrecioUSD
                                        )}
                                      </td>
                                      <td className="text-end">
                                        USD{" "}
                                        {formatoUSD(
                                          item.comisionBaseUSD
                                        )}
                                      </td>
                                      <td
                                        className={`text-end fw-semibold ${
                                          Number(
                                            item.porcentajeAjuste
                                          ) > 0
                                            ? "text-success"
                                            : Number(
                                                item.porcentajeAjuste
                                              ) < 0
                                            ? "text-danger"
                                            : ""
                                        }`}
                                      >
                                        {Number(
                                          item.porcentajeAjuste
                                        ) > 0
                                          ? "+"
                                          : ""}
                                        {Number(
                                          item.porcentajeAjuste ||
                                            0
                                        )}
                                        %
                                      </td>
                                      <td className="text-end fw-bold">
                                        USD{" "}
                                        {formatoUSD(
                                          item.comisionTotalUSD
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={9}
                                    className="text-center text-muted py-4"
                                  >
                                    La venta no posee productos
                                    para calcular.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                          <Row className="g-2">
                            <Col
                              xs={12}
                              md={4}
                            >
                              <div className="border rounded p-2">
                                <div className="small text-muted">
                                  Ítems de la venta
                                </div>
                                <strong>
                                  {Number(
                                    previewComision
                                      ?.resultado
                                      ?.cantidadItems ||
                                      0
                                  )}
                                </strong>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                            >
                              <div className="border rounded p-2">
                                <div className="small text-muted">
                                  Ítems comisionables
                                </div>
                                <strong>
                                  {Number(
                                    previewComision
                                      ?.resultado
                                      ?.cantidadItemsComisionables ||
                                      0
                                  )}
                                </strong>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                            >
                              <div className="border rounded p-2">
                                <div className="small text-muted">
                                  Productos computados
                                </div>
                                <strong>
                                  {Number(
                                    previewComision
                                      ?.resultado
                                      ?.cantidadProductosComisionados ||
                                      0
                                  )}
                                </strong>
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </>
                  )}
                </Tab>
              </Tabs>
            {/* BOTONES */}
            {![
            "productos",
            "pendientes",
            "historial",
            "resumen-semanal",
            "resumen-mensual",
            "liquidaciones",
            "pagos",
            "cuenta-corriente",
            "preview",
            ].includes(tabActiva) && (
            <div className="d-flex flex-wrap gap-2 border-top pt-3 mt-3">
                <Button
                variant="primary"
                onClick={guardar}
                disabled={guardando}
                >
                {guardando ? (
                    <>
                    <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                    />
                    Guardando...
                    </>
                ) : (
                    <>
                    <FiSave className="me-2" />
                    {formulario._id
                        ? "Guardar cambios"
                        : "Guardar configuración"}
                    </>
                )}
                </Button>
                <Button
                variant="outline-primary"
                onClick={nuevaVigencia}
                >
                <FiPlus className="me-1" />
                Nueva vigencia
                </Button>
            </div>
            )}
            </Card.Body>
          </Card>
        </Col>
        {/* PANEL DERECHO */}
        <Col
          xs={12}
          xl={3}
        >
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body>
              <h6 className="fw-bold">
                <FiSettings className="me-2" />
                Resumen
              </h6>
              <hr />
              <div className="resumen-linea">
                <span>
                  Sede
                </span>
                <strong>
                  {
                    formulario.sede
                  }
                </strong>
              </div>
              <div className="resumen-linea">
                <span>
                  Regla progresiva
                </span>
                <strong>
                  {formulario.aplicaReglaProgresiva
                    ? "Sí"
                    : "No"}
                </strong>
              </div>
              {formulario.aplicaReglaProgresiva && (
                <>
                  <div className="resumen-linea">
                    <span>
                      Tramo
                    </span>
                    <strong>
                      USD{" "}
                      {
                        formulario.tramoPrecioUSD
                      }
                    </strong>
                  </div>
                  <div className="resumen-linea">
                    <span>
                      Variación
                    </span>
                    <strong>
                      {
                        formulario.porcentajeVariacion
                      }
                      %
                    </strong>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body>
              <h6 className="fw-bold">
                <FiGift className="me-2" />
                Bonos
              </h6>
              <div className="resumen-linea mt-3">
                <span>
                  Semanales
                </span>
                <strong>
                  {
                    formulario
                      .bonosSemanales
                      .tramos.length
                  }
                </strong>
              </div>
              <div className="resumen-linea">
                <span>
                  Mensuales
                </span>
                <strong>
                  {formulario
                    .bonosMensuales
                    .tipo ===
                  "RANKING"
                    ? formulario
                        .bonosMensuales
                        .ranking
                        .length
                    : formulario
                        .bonosMensuales
                        .tramos
                        .length}
                </strong>
              </div>
            </Card.Body>
          </Card>
          <Card className="shadow-sm border-0">
            <Card.Body>
              <h6 className="fw-bold">
                <FiCheckCircle className="me-2" />
                Seguridad
              </h6>
              <div className="small text-muted">
                La administración de
                estas reglas está
                actualmente restringida
                a ROOT.
              </div>
              <div className="small text-muted mt-2">
                Modificar una regla no
                modifica las ventas
                existentes.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* HISTÓRICO */}
      <Card className="shadow-sm border-0 mt-3">
        <Card.Body>
          <h6 className="fw-bold mb-3">
            Configuraciones registradas
          </h6>
          <Table
            responsive
            hover
            className="align-middle mb-0"
          >
            <thead>
            <tr>
                <th>Sede</th>
                <th>Desde</th>
                <th>Hasta</th>
                <th>Regla</th>
                <th>Tramo USD</th>
                <th>Variación</th>
                <th>Bonos semanales</th>
                <th>Bonos mensuales</th>
                <th>Estado</th>
                <th className="text-end">
                Acción
                </th>
            </tr>
            </thead>
            <tbody>
              {configuraciones.length ===
              0 ? (
                <tr>
                  <td
                    colSpan={10}
                    className="text-center text-muted py-4"
                  >
                    Todavía no hay
                    configuraciones
                    cargadas.
                  </td>
                </tr>
              ) : (
                configuraciones.map(
                  (config) => (
                    <tr
                      key={
                        config._id
                      }
                    >
                      <td className="fw-semibold">
                        {
                          config.sede
                        }
                      </td>
                      <td>
                        {fechaInput(
                          config.vigenteDesde
                        )}
                      </td>
                      <td>
                        {config.vigenteHasta
                          ? fechaInput(
                              config.vigenteHasta
                            )
                          : "Sin límite"}
                      </td>
                        <td>
                        {config.aplicaReglaProgresiva
                            ? (
                            <Badge bg="success">
                                Sí
                            </Badge>
                            )
                            : (
                            <Badge bg="secondary">
                                No
                            </Badge>
                            )}
                        </td>
                      <td>
                        USD{" "}
                        {Number(
                            config.tramoPrecioUSD || 0
                        ).toLocaleString("en-US")}
                        </td>
                        <td>
                        {Number(
                            config.porcentajeVariacion || 0
                        )}
                        %
                      </td>
                      <td>
                        {config?.bonosSemanales?.activo &&
                        Array.isArray(
                            config?.bonosSemanales?.tramos
                        ) &&
                        config.bonosSemanales.tramos.length > 0
                            ? config.bonosSemanales.tramos
                                .map(
                                (bono) =>
                                    `${bono.cantidad}→$${bono.montoUSD}`
                                )
                                .join(" · ")
                            : "—"}
                        </td>
                        <td>
                        {config?.bonosMensuales?.activo &&
                        Array.isArray(
                            config?.bonosMensuales?.tramos
                        ) &&
                        config.bonosMensuales.tramos.length > 0
                            ? config.bonosMensuales.tramos
                                .map(
                                (bono) =>
                                    `${bono.cantidad}→$${bono.montoUSD}`
                                )
                                .join(" · ")
                            : "—"}
                        </td>
                      <td>
                        <Badge
                          bg={
                            config.activo !==
                            false
                              ? "success"
                              : "secondary"
                          }
                        >
                          {config.activo !==
                          false
                            ? "Activa"
                            : "Inactiva"}
                        </Badge>
                      </td>
                      <td className="text-end">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => {
                          setSedeSeleccionada(
                              config.sede
                          );
                          cargarEnFormulario(
                              config
                          );
                          setTabActiva(
                              "general"
                          );
                          setMensaje(
                              `Editando configuración de ${config.sede}. Los cambios se guardarán sobre esta vigencia.`
                          );
                          window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                          });
                          }}
                        >
                          <FiEdit2 />
                        </Button>
                      </td>
                    </tr>
                  )
                )
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <Modal
        show={modalPagoAbierto}
        onHide={cerrarModalPago}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Registrar pago de comisión
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {liquidacionPago && (
            <>
              <Card className="border mb-3">
                <Card.Body className="py-2">
                  <Row className="g-2">
                    <Col xs={12}>
                      <div className="small text-muted">
                        Vendedor
                      </div>
                      <div className="fw-bold">
                        {[
                          liquidacionPago
                            ?.vendedor
                            ?.nombres,
                          liquidacionPago
                            ?.vendedor
                            ?.apellidos,
                        ]
                          .filter(Boolean)
                          .join(" ") ||
                          liquidacionPago
                            ?.vendedor
                            ?.email ||
                          "-"}
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="small text-muted">
                        Tipo
                      </div>
                      <Badge
                        bg={
                          liquidacionPago.tipo === "MENSUAL"
                            ? "info"
                            : "secondary"
                        }
                      >
                        {liquidacionPago.tipo === "MENSUAL"
                          ? "Mensual"
                          : "Semanal"}
                      </Badge>
                    </Col>
                    <Col xs={6}>
                      <div className="small text-muted">
                        Período
                      </div>
                      <strong>
                        {fechaInput(
                          liquidacionPago.periodoDesde
                        )}
                        {" → "}
                        {fechaInput(
                          liquidacionPago.periodoHasta
                        )}
                      </strong>
                    </Col>
                    <Col xs={6}>
                      <div className="small text-muted">
                        Liquidado
                      </div>
                      <strong>
                        USD{" "}
                        {formatoUSD(
                          liquidacionPago
                            .totalLiquidacionUSD
                        )}
                      </strong>
                    </Col>
                    <Col xs={6}>
                      <div className="small text-muted">
                        Pagado
                      </div>
                      <strong className="text-success">
                        USD{" "}
                        {formatoUSD(
                          liquidacionPago
                            .totalPagadoUSD
                        )}
                      </strong>
                    </Col>
                    <Col xs={12}>
                      <div className="small text-muted">
                        Saldo pendiente
                      </div>
                      <div className="fs-5 fw-bold text-warning">
                        USD{" "}
                        {formatoUSD(
                          liquidacionPago
                            .saldoPendienteUSD
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Row className="g-3">
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Fecha de pago
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={
                        formularioPago.fechaPago
                      }
                      onChange={(e) =>
                        setFormularioPago(
                          (prev) => ({
                            ...prev,
                            fechaPago:
                              e.target.value,
                          })
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>
                      Monto USD
                    </Form.Label>
                    <Form.Control
                      type="number"
                      min="0.01"
                      step="0.01"
                      max={
                        Number(
                          liquidacionPago
                            .saldoPendienteUSD ||
                            0
                        )
                      }
                      value={
                        formularioPago.montoUSD
                      }
                      onChange={(e) =>
                        setFormularioPago(
                          (prev) => ({
                            ...prev,
                            montoUSD:
                              e.target.value,
                          })
                        )
                      }
                      autoFocus
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>
                      Referencia
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej: transferencia, recibo, comprobante..."
                      value={
                        formularioPago.referencia
                      }
                      onChange={(e) =>
                        setFormularioPago(
                          (prev) => ({
                            ...prev,
                            referencia:
                              e.target.value,
                          })
                        )
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group>
                    <Form.Label>
                      Observaciones
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={
                        formularioPago.observaciones
                      }
                      onChange={(e) =>
                        setFormularioPago(
                          (prev) => ({
                            ...prev,
                            observaciones:
                              e.target.value,
                          })
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={cerrarModalPago}
            disabled={registrandoPago}
          >
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={
              registrarPagoLiquidacion
            }
            disabled={
              registrandoPago ||
              !formularioPago.montoUSD
            }
          >
            {registrandoPago ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Registrando...
              </>
            ) : (
              <>
                <FiDollarSign className="me-2" />
                Registrar pago
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
